/* ============================================================
   bb3.js — Créateur de bracelet Italian Charms
   Repris ligne à ligne de la preview validée.
   Seules différences : les charms viennent de Shopify, le bouton
   panier appelle /cart/add.js, et l'état est mémorisé.
   ============================================================ */
/* ── Preuve de chargement ────────────────────────────────────────
   Cette ligne s'exécute avant tout le reste. Si le diagnostic reste
   sur « le script ne s'est pas exécuté », c'est que le navigateur
   n'a jamais reçu ce fichier : il n'est pas dans assets/, ou son
   nom diffère de bb3.js. Si le message change, le fichier est bien
   là et le problème est ailleurs — il sera affiché en rouge.
   ──────────────────────────────────────────────────────────────── */
(function(){
  var d = document.getElementById('bb3-diag-js');
  if (d) d.textContent = 'JS : fichier bb3.js chargé, initialisation…';
  window.addEventListener('error', function (ev) {
    var t = document.getElementById('bb3-diag-js');
    if (t && ev && ev.message) {
      t.innerHTML = '<em>JS EN ERREUR : ' + ev.message + ' — ' +
        (ev.filename || '').split('/').pop() + ' ligne ' + (ev.lineno || '?') + '</em>';
    }
  });
})();

(function(){
'use strict';

/* Écrit dans l'encadré de diagnostic de l'éditeur de thème.
   Défini ici, avant tout le reste, pour être disponible partout. */
/* ══════════════════════════════════════════════════════════════
   TEXTES — un seul endroit à traduire.
   Rien n'est écrit en dur ailleurs dans ce fichier. Pour une autre
   langue, il suffit de traduire ce bloc, ou de passer un objet
   window.BB3_I18N avant le chargement du script pour l'écraser.
   ══════════════════════════════════════════════════════════════ */
var TXT_DEF = {
  ajouter:        'Ajouter',
  ajoute:         '✓ Ajouté',
  ajoutEnCours:   'Ajout en cours…',
  voirPlus:       'Voir {n} charms de plus · {reste} restants',
  affiches:       '<b>{n}</b> charms affichés sur <b>{total}</b>',
  pisteVide:      'Ajoute ton premier charm',
  aideVide:       'Touche un maillon vide pour choisir où poser ton premier charm',
  aidePosee:      'Glisse un charm pour le déplacer · touche un maillon vide pour choisir où poser le suivant',
  aideCible:      'Maillon choisi. Touche un charm ci-dessous pour l\'y poser.',
  longueurDetail: '{total} maillons + {ajout}',
  longueurBase:   '{std} maillons',
  charm:          'charm',
  charms:         'charms',
  longueurMax:    'longueur maximale',
  longueurAtteinte:'Longueur maximale atteinte pour un bracelet',
  plusDePlace:    'Plus de place sur ce bracelet',
  charmRetire:    'Charm retiré',
  stockMax:       'Il n\'en reste que {n} en stock',
  epuise:         'Épuisé pour le moment',
  braceletInclus: 'Bracelet inclus',
  braceletNon:    'Sans bracelet — charms seuls',
  braceletDeja:   'J\'en ai déjà un',
  braceletAjout:  'Ajouter le bracelet',
  braceletOffert: '🎁 Bracelet offert',
  offert:         'Offert',
  total:          'Total',
  livOfferte:     '✓ Livraison offerte',
  livDe:          'de livraison · offerte dès {seuil} en point relais',
  maillonN:       '{nom} : maillon {n}',
  braceletLbl:    'Bracelet {couleur}',
  partageTitre:   'Mon bracelet',
  bracelet:       'bracelet',
  retirerX:       'Retirer {nom}',
  retirerOutil:   'Retirer l\'outil',
  retirerListe:   'Retirer de la liste',
  plusQue:        'Plus que',
  etBraceletOffert:'et le bracelet est offert',
  etRemise:       'et tu passes à −{pct} %',
  remiseDes:      '−{pct} % dès {n} charms',
  videRecap:      'Ajoute tes charms pour commencer ✨',
  valider:        'Valider mon pack',
  choisirLettre:  'Choisis ta lettre',
  lettreMax:      'Plus assez de stock pour cette lettre',
  lettreEpuisee:  'Cette lettre est épuisée',
  laLettre:       'la lettre',
  ajouterLettre:  'Ajouter la lettre',
  retirerLettre:  'Retirer la lettre',
  aucuneLettre:   'Aucune lettre pour l’instant',
  choisisUneLettre: 'Choisis au moins une lettre',
  ajouter1Lettre: 'Ajouter 1 lettre',
  ajouterNLettres: 'Ajouter {n} lettres',
  disponible:     'Disponible',
  epuiseeLeg:     'Épuisée',
  choisirMois:    'Choisis ton mois',
  validerModal:   'Valider',
  listeCopiee:    'Liste copiée',
  lienCopie:      'Lien copié',
  maListe:        'Ma liste de charms',
  listeIntro:     'Les charms qui me plaisent :',
  indispo:        'Ce charm est épuisé pour le moment',
  braceletVide:   'Bracelet vidé',
  couleurLbl:     'Couleur',
  motifLbl:       'Motif',
  motifEpuise:    'Victime de son succès',
  motifEpuiseToast: 'Ce motif n’est plus en stock dans cette couleur',
  braceletEpuise: 'Ce bracelet est épuisé dans cette couleur : choisis-en une autre.',
  outilEpuise:    'L\'outil est épuisé pour le moment.',
  erreurPanier:   'L\'ajout au panier n\'a pas fonctionné. Réessaie dans un instant.',
  /* 02/11/2026 : maquette v4 (barre de progression + panneau « Ta sélection ») */
  v4N1:           '{n} charm',
  v4N:            '{n} charms',
  v4Encore:       'Encore <b>{n}</b> pour le bracelet offert',
  v4BrOk:         'Bracelet offert',
  v4Tout:         'Tout est débloqué',
  v4EncoreLiv:    'Encore <b>{x}</b> pour la livraison offerte',
  v4MLiv:         'Livraison<br>offerte',
  v4MBr:          'Bracelet<br>offert · {n}',
  v4Sel:          'Ta sélection',
  v4MsgEncore:    'Encore <b>{n}</b> pour ton <b>bracelet offert</b>',
  v4MsgBr:        '<b>Bracelet offert</b> débloqué',
  v4MsgTout:      'Tu as tout débloqué : <b>bracelet offert</b> et livraison offerte',
  v4SousTotal:    'Sous-total',
  v4LivOk:        'Livraison offerte en point relais',
  v4LivNo:        'Livraison offerte dès {seuil}',
  v4Eco:          'Tu économises {x}',
  v4Autres:       '+ {n} autres',
  v4Moins:        'Retirer un',
  v4Plus:         'Ajouter un',
  v4Vider:        'Tout vider'
};

/* Les textes de l'éditeur écrasent les défauts, mais jamais au prix
   d'un affichage cassé : un champ vide, ou dont les repères {n} ont
   été supprimés à la traduction, retombe sur le texte d'origine. */
var TXT = (function(){
  var src = window.BB3_I18N || {}, out = {};
  Object.keys(TXT_DEF).forEach(function(k){ out[k] = TXT_DEF[k]; });
  Object.keys(src).forEach(function(k){
    var v = src[k];
    if (typeof v === 'string' && v.trim()) out[k] = v;
  });
  return out;
})();

function tr(cle, vars){
  var v = TXT[cle], def = TXT_DEF[cle];
  if (typeof v !== 'string' || !v) v = (typeof def === 'string' ? def : cle);
  if (vars) {
    /* Si un repère manque dans le texte réécrit, on reprend l'original :
       mieux vaut la phrase de départ qu'une phrase sans son chiffre. */
    var incomplet = Object.keys(vars).some(function(k){ return v.indexOf('{' + k + '}') === -1; });
    if (incomplet && typeof def === 'string') v = def;
    Object.keys(vars).forEach(function(k){ v = v.split('{' + k + '}').join(vars[k]); });
  }
  /* Filet final : aucun repère orphelin ne peut s'afficher. */
  return v.replace(/\{[A-Za-z]+\}/g, '').replace(/\s{2,}/g, ' ').trim();
}

/* Repère les éléments plus larges que la fenêtre : c'est eux qui
   permettent de faire glisser la page latéralement. */
function chercherDebordement(){
  var d = document.getElementById('bb3-diag-js');
  if (!d) return;
  var L = document.documentElement.clientWidth, coupables = [];
  var tout = document.body.getElementsByTagName('*');
  for (var i = 0; i < tout.length; i++) {
    var el = tout[i], r = el.getBoundingClientRect();
    if (r.width === 0) continue;
    if (r.right > L + 1 || r.left < -1) {
      var st = getComputedStyle(el);
      if (st.overflowX === 'auto' || st.overflowX === 'scroll') continue;
      var p = el.parentElement, cache = false;
      while (p && p !== document.body) {
        var ps = getComputedStyle(p);
        if (ps.overflowX === 'hidden' || ps.overflowX === 'clip' ||
            ps.overflowX === 'auto' || ps.overflowX === 'scroll') { cache = true; break; }
        p = p.parentElement;
      }
      if (cache) continue;
      coupables.push((el.tagName.toLowerCase()) +
        (el.id ? '#' + el.id : '') +
        (el.className && typeof el.className === 'string' ? '.' + el.className.trim().split(/\s+/).slice(0,2).join('.') : '') +
        ' [' + Math.round(r.left) + '→' + Math.round(r.right) + ']');
      if (coupables.length >= 6) break;
    }
  }
  var ligne = document.createElement('span');
  /* Message d'éditeur, jamais vu par une cliente : il ne passe donc
     pas par le dictionnaire de traduction. */
  ligne.innerHTML = coupables.length
    ? '<em>Débordent de la fenêtre (' + L + ' px) : ' + coupables.join(' · ') + '</em>'
    : 'Aucun débordement horizontal détecté.';
  d.parentNode.appendChild(ligne);
}

function diag(txt, erreur){
  var d = document.getElementById('bb3-diag-js');
  if (!d) return;
  d.innerHTML = erreur ? '<em>JS EN ERREUR : ' + txt + '</em>' : 'JS : ' + txt;
}

try {
var CFGS = window.BB3_CONFIG || {};
/* Taux de change EUR → devise affichée (1 si la devise est déjà l'EUR). */
var TAUX = (function(){
  try {
    var c = window.Shopify && window.Shopify.currency;
    if (c && c.active && c.active !== 'EUR' && c.active === (CFGS.devise || c.active)) {
      var r = parseFloat(c.rate); if (r > 0 && isFinite(r)) return r;
    }
  } catch(e) {}
  return 1;
})();
var DATA = { charms: [] };
/* Les cartes sont écrites par Liquid. On les lit, on ne les recrée pas :
   même si le JS tombe, les charms restent visibles dans la page. */
/* « coeur » doit trouver « Cœur », « etoile » trouver « Étoile » */
function sansAccent(t){
  t=(t||'').toString().toLowerCase().replace(/œ/g,'oe').replace(/æ/g,'ae');
  try{ t=t.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(e){}
  return t;
}
function lireCartes(){
  DATA.charms = [];
  Array.prototype.forEach.call(document.querySelectorAll('#grille [data-bb3-charm]'), function(el){
    var t = (el.dataset.type||'plat').toLowerCase();
    var c = {
      el: el,
      id: el.dataset.id,
      vid: el.dataset.vid,
      nom: el.dataset.nom || '',
      handle: el.dataset.handle || '',
      prix: parseInt(el.dataset.prix,10) || 0,
      type: t,
      couleur: el.dataset.couleur || '',
      cat: el.dataset.cat || '',
      cats: el.dataset.cats || (',' + (el.dataset.cat || '') + ','),
      tags: el.dataset.tags || '',
      img: el.dataset.img || el.dataset.photo || '',
      photo: el.dataset.photo || el.dataset.img || '',
      dispo: el.dataset.dispo !== 'false',
      /* 27/10/2026 : stock réel de la variante, pour bloquer au clic et non au panier */
      qte: (el.dataset.qte!==undefined && el.dataset.qte!=='') ? parseInt(el.dataset.qte,10) : null,
      suivi: el.dataset.suivi==='shopify' && el.dataset.policy!=='continue',
      modale: el.dataset.modale || '',
      /* Lettres : « A|id|photo|true;B|… » → une variante par lettre */
      vars: (el.dataset.vars || '').split(';').filter(Boolean).map(function(x){
        var q = x.split('|');
        var n = parseInt(q[4], 10);
        return { t: q[0], id: q[1], img: q[2] || '', d: q[3] !== 'false', q: isNaN(n) ? null : n };
      })
    };
    if (!c.vars.length) c.vars = null;
    /* On mémorise les sous-éléments : rGrille faisait 4 querySelector
       par carte, soit 2 000 requêtes DOM à chaque frappe sur 500 cartes. */
    c.elN   = el.querySelector('.bb2-charm__n');
    c.elQty = el.querySelector('.bb2-charm__qty');

    c.elCo  = el.querySelector('.coeur');
    c.cherche = sansAccent(c.nom+' '+c.couleur+' '+c.tags);
    el.__c = c;
    DATA.charms.push(c);
  });
}
var RACINE = document.getElementById('bb3');
if(!RACINE) return;
var CLE='bb3_state_v2', TTL=30*24*3600*1000;

var PORTEE={plat:1,pendentif:1,double:2,chaine3:3,chaine4:4};
/* Deux paliers. « Prix dégressif » est la 1re raison de revenir citée
   dans le questionnaire (55,8 %), devant le charm offert (51 %).
   Les seuils sont à trancher, la mécanique est là. */
var CFG={
  std:          CFGS.maillonsStd    || 18,
  max:          (CFGS.maxMaillons>0) ? CFGS.maxMaillons : 500,   /* 0 = pas de limite */
  braceletOffertA: CFGS.braceletOffertA || 10,
  degressifA:   (CFGS.degressifA !== undefined) ? CFGS.degressifA : 0,   /* 0 = pas de remise dégressive */
  degressifPct: CFGS.degressifPct   || 10,
  /* Seuils saisis en euros dans l'éditeur ; sur un marché en devise
     locale (USD, GBP…), Shopify.currency.rate convertit depuis l'EUR. */
  livDes:       Math.round((CFGS.livOfferteDes  || 5000) * TAUX),
  /* 02/11/2026 : seuil affiché (50 €) ; le seuil réel peut être un peu plus bas (49 €) */
  livAff:       Math.round((CFGS.livAffiche || CFGS.livOfferteDes || 5000) * TAUX),
  liv:          Math.round((CFGS.coutLivraison  || 690)  * TAUX),
  prixBracelet: 0,
  prixOutil:    (CFGS.outil && CFGS.outil.prix) || 0
};
var BLOCS = (CFGS.couleurs || []).filter(function(c){ return c && c.nom; });
/* Variantes réelles du produit : c'est elles qui font foi pour le prix
   et l'identifiant, pas la saisie des blocs. */
var VARS = (CFGS.variantes || []).filter(function(v){ return v && v.c; });
/* ══════════════════════════════════════════════════════════════
   Le sélecteur est construit À PARTIR DES VARIANTES DU PRODUIT.
   Aucune saisie n'est nécessaire : toutes les variantes disponibles
   apparaissent d'office, avec leur prix et leur identifiant réels.
   Les blocs couleur ne servent plus qu'à enrichir — image de maillon,
   pastille, libellé sur mesure — et sont facultatifs.
   ══════════════════════════════════════════════════════════════ */
function tonDe(nom){
  var n = norm(nom);
  /* Les noms de variante peuvent être traduits (Silver, Silber, Plata, Argento, Zilver…). */
  if(/argent|silver|silber|plata|zilver|acier|steel|stahl|acero|acciaio|staal/.test(n)) return 'ar';
  return 'or';
}
var PASTILLES = {
  'or':        'linear-gradient(150deg,#F7DFA8,#E3B25E 52%,#B98529)',
  'dore':      'linear-gradient(150deg,#F7DFA8,#E3B25E 52%,#B98529)',
  'argent':    'linear-gradient(150deg,#FBFBFA,#D2D1CB 52%,#9A9992)',
  'argente':   'linear-gradient(150deg,#FBFBFA,#D2D1CB 52%,#9A9992)',
  'or rose':   'linear-gradient(150deg,#F6D8CE,#E8A9A0 52%,#C4756C)',
  'rose gold': 'linear-gradient(150deg,#F6D8CE,#E8A9A0 52%,#C4756C)'
};
function pastilleDe(nom, ton){
  var p = PASTILLES[norm(nom).replace(/[éè]/g,'e')];
  return p || PASTILLES[ton==='ar'?'argent':'or'];
}
function motifK(m){
  /* 03/11/2026 : type de motif quelle que soit la langue (Étoiles/Stars/Sterne…, Cœurs/Hearts/Herzen…) */
  var n=norm(m||'').replace(/œ/g,'oe');
  if(/toil|star|stern|estrell|stell|ster/.test(n)) return 'e';
  if(/coeur|heart|herz|coraz|cuor|hart/.test(n)) return 'c';
  return 's';
}
function blocDe(c, m){
  for(var i=0;i<BLOCS.length;i++){
    var b=BLOCS[i];
    if(norm(b.nom)!==norm(c)) continue;
    if(b.motif && norm(b.motif)!==norm(m)) continue;
    return b;
  }
  /* Repli (marchés traduits : Gold/Silber, Stars/Sterne…) : même métal et même type de motif.
     L'or rose n'a pas d'image à motif : il garde le maillon uni. */
  var t=tonDe(c), rose=/rose|rosa|rosé/.test(norm(c)), k=rose?'s':motifK(m);
  for(var j=0;j<BLOCS.length;j++){
    var b2=BLOCS[j];
    if((b2.ton || tonDe(b2.nom))===t && motifK(b2.motif)===k) return b2;
  }
  for(var j2=0;j2<BLOCS.length;j2++){
    var b4=BLOCS[j2];
    if((b4.ton || tonDe(b4.nom))===t && motifK(b4.motif)==='s') return b4;
  }
  for(var k2=0;k2<BLOCS.length;k2++){
    var b3=BLOCS[k2]; if((b3.ton || tonDe(b3.nom))===t) return b3;
  }
  return null;
}
var COULEURS = (function(){
  var out=[], vus=[];
  (CFGS.variantes||[]).forEach(function(v){
    if(!v || !v.c) return;
    /* les variantes épuisées restent visibles, avec le badge « 0 en stock » */
    var cle = norm(v.c)+'|'+norm(v.m||'');
    if(vus.indexOf(cle)>=0) return;
    vus.push(cle);
    var b = blocDe(v.c, v.m) || {};
    var ton = b.ton || tonDe(v.c);
    /* « Or » pour la variante de base, « Or étoiles » sinon */
    var base = norm(v.m||'');
    var lbl = b.libelle ||
      ((!v.m || base==='classique' || base==='simple' || base==='basique')
        ? v.c : v.c + ' ' + v.m.toLowerCase());
    out.push({
      id: (norm(v.c)+'-'+norm(v.m||'')).replace(/[^a-z0-9]+/g,'-'),
      nom: v.c, motif: v.m || '', libelle: lbl, ton: ton,
      rond: b.rond || pastilleDe(v.c, ton),
      img: b.img || '', photo: v.photo || '', note: b.note || '',
      variantId: v.id, prix: v.prix, dispo: v.dispo !== false
    });
  });
  /* aucune variante transmise : on retombe sur les blocs, puis sur un défaut */
  if(!out.length) out = BLOCS.slice();
  if(!out.length) out = [{id:'or',nom:'Doré',motif:'',libelle:'Doré',ton:'or',rond:PASTILLES.or,img:'',note:''}];
  return out;
})();

function motifsDe(nom){
  var vus=[], out=[];
  VARS.forEach(function(v){ if(v.c===nom && v.m && vus.indexOf(v.m)<0){ vus.push(v.m); out.push(v); } });
  return out;
}
function variantePour(nom, motif){
  for(var i=0;i<VARS.length;i++){
    if(VARS[i].c!==nom) continue;
    if(!motif || VARS[i].m===motif) return VARS[i];
  }
  for(var j=0;j<VARS.length;j++) if(VARS[j].c===nom) return VARS[j];
  return null;
}
/* Le bloc couleur apporte le métal et l'image de maillon ; on prend
   celui qui correspond au motif, sinon celui de la couleur. */
function blocPour(nom, motif){
  var large=null;
  for(var i=0;i<COULEURS.length;i++){
    var c=COULEURS[i];
    if(c.nom!==nom) continue;
    if(motif && c.motif===motif) return c;
    if(!large) large=c;
  }
  return large;
}
function majCouleur(){
  var v=variantePour(S.couleur.nom, S.motif);
  var b=blocPour(S.couleur.nom, S.motif) || S.couleur;
  S.couleur = {
    id: b.id, nom: S.couleur.nom, motif: S.motif, libelle: b.libelle, ton: b.ton, rond: b.rond,
    img: b.img, photo: b.photo, note: b.note,
    variantId: v ? v.id : b.variantId,
    prix: v ? v.prix : b.prix,
    dispo: v ? v.dispo : true
  };
}
var CATS = CFGS.cats || [{id:'tous',n:'Tous'}];
var LETTRES = CFGS.lettres || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var MOIS = CFGS.mois || ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
var METAL={};
(CFGS.metalMap||'doré:or,argenté:ar').split(/[,\n]/).forEach(function(l){
  var kv=l.split(':'); if(kv.length>=2){var k=norm(kv[0]),v=norm(kv[1]); if(k&&v)METAL[k]=v;}});
var BEST = CFGS.best || [];
var NOUV = CFGS.nouveautes || [];

/* Tous les charms sont affichés, sans pagination ni bouton. */
var PAR_LOT = Infinity;
var BR_MAX=3; /* 1 bracelet + 2 en plus au maximum */
/* Bracelets en plus (payants) : S.brx = liste d'identifiants de COULEURS,
   un par bracelet ajouté. Chacun peut avoir sa couleur. */
function brCoul(id){ for(var i=0;i<COULEURS.length;i++) if(COULEURS[i].id===id) return COULEURS[i]; return null; }
function brxListe(){ return (S.brx||[]).map(brCoul).filter(Boolean); }
function brChoix(){
  /* une vignette par variante en stock : couleur ET motif (Or, Or étoiles, Argent cœurs…) */
  return COULEURS.filter(function(c){ return c.dispo!==false; });
}
var S={brx:[],mode:'first',couleur:(COULEURS.filter(function(c){return c.dispo!==false;})[0]||COULEURS[0]),motif:'',pose:[],outil:false,cat:'tous',q:'',cible:null,limite:PAR_LOT,wish:[]};
(function(){
  var d=motifsDe(S.couleur.nom), dd=d.filter(function(v){return v.dispo!==false;});
  S.motif = S.couleur.motif || (dd.length ? dd[0].m : (d.length ? d[0].m : ''));
  majCouleur();
})();
/* Déclarée ici et pas après le bloc qui l'assigne : « var BR_MAJ=null »
   placé plus bas s'exécutait APRÈS « BR_MAJ=maj » et l'écrasait, si bien
   que le compteur de la pastille « Mon bracelet » ne se mettait jamais à jour. */
var BR_MAJ=null;
var sel=null,neuf=null,seq=0,dernier=null;
/* Un id absent renvoie un élément fantôme plutôt que null : une seule
   pièce manquante ne peut plus interrompre tout le configurateur. */
var FANTOME = document.createElement('div');
function $(i){ return document.getElementById(i) || FANTOME; }
function qq(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
/* Devise et séparateurs viennent de la boutique, jamais écrits en dur :
   une boutique en USD affichera $12.99, une boutique en CHF CHF 12.90. */
var FMT = null;
try {
  /* On ne force PAS le nombre de décimales : Intl connaît les devises
     sans décimale comme le yen ou le won, et les affichera correctement. */
  FMT = new Intl.NumberFormat(CFGS.locale || 'fr-FR', {
    style: 'currency', currency: CFGS.devise || 'EUR'
  });
} catch(e) { FMT = null; }
/* Shopify stocke les montants en centièmes, y compris pour les devises
   sans décimale : la division par 100 reste correcte dans tous les cas. */
function eur(c){
  var n = (c || 0) / 100;
  if (FMT) { try { return FMT.format(n); } catch(e) {} }
  return n.toFixed(2) + ' ' + (CFGS.devise || 'EUR');
}
function norm(s){return (s||'').toString().trim().toLowerCase();}
/* Ajuste la largeur d'un maillon pour que tout le bracelet tienne
   dans la piste. Entre 15 et 46 px. Au-delà de ~28 maillons on laisse
   défiler, avec défilement automatique pendant le glisser. */
/* On cherche à faire tenir tout le bracelet à l'écran, mais jamais en
   dessous d'une taille où le charm reste reconnaissable : 24 px sur
   téléphone, 28 px sur ordinateur. En dessous, on laisse défiler.
   Sur un écran de 360 px avec 18 maillons, il manque 63 px : la piste
   défile d'un demi-maillon, avec défilement automatique pendant le glisser. */
function ajusterCase(total){
  var el=$('piste'); if(!el||!total)return;
  var vp=window.innerWidth;
  var dispo=el.clientWidth-(vp<720?36:52);
  /* Plancher relevé : en dessous, le motif du charm n'est plus lisible.
     Le bracelet dépasse alors de l'écran, mais il défile. */
  var mini=vp<720?32:40, maxi=vp<1000?50:56;
  var c=Math.max(mini,Math.min(maxi,dispo/(0.89*(total-1)+1)));
  RACINE.style.setProperty('--case',c.toFixed(2)+'px');
  RACINE.style.setProperty('--caseH',(c*110/128).toFixed(2)+'px');
  /* on signale visuellement que le bracelet dépasse */
  var large=c*(0.89*(total-1)+1);
  el.classList.toggle('deborde', large>dispo+2);
}
function geo(){var c=parseFloat(getComputedStyle(RACINE).getPropertyValue('--case'));return{c:c,p:c*0.89};}

function cases(t,s){if(t==='chaine3')return[s,s+2];if(t==='chaine4')return[s,s+3];if(t==='double')return[s,s+1];return[s];}
function portee(t){return PORTEE[t]||1;}
function occ(sauf){var o={};S.pose.forEach(function(p){if(p.uid===sauf)return;cases(p.type,p.start).forEach(function(c){o[c]=p;});});return o;}
function libresChaine(){var o={};S.pose.forEach(function(p){if(p.type!=='chaine3'&&p.type!=='chaine4')return;
  for(var k=p.start+1;k<p.start+portee(p.type)-1;k++)o[k]=true;});return o;}
function libre(t,s,sauf){if(s<0)return false;var o=occ(sauf);return cases(t,s).every(function(c){return !o[c];});}
function place(t,o){for(var s=0;s<CFG.max;s++){if(cases(t,s).every(function(c){return !o[c];}))return s;}return -1;}
function etendue(){var m=0;S.pose.forEach(function(p){m=Math.max(m,p.start+portee(p.type));});return m;}
function replacer(ord){var o={};ord.forEach(function(p){var s=place(p.type,o);if(s<0)return;p.start=s;
  cases(p.type,s).forEach(function(c){o[c]=1;});});}
function ordre(){return S.pose.slice().sort(function(a,b){return a.start-b.start;});}
function compacter(){replacer(ordre());}
function parUid(u){for(var i=0;i<S.pose.length;i++)if(S.pose[i].uid===u)return S.pose[i];return null;}
function charm(id){for(var i=0;i<DATA.charms.length;i++)if(DATA.charms[i].id===id)return DATA.charms[i];return null;}

/* ── rendus ── */
/* Deux rangées : la couleur du bracelet, puis le motif disponible dans
   cette couleur. Le produit a bien deux options, pas une. */
/* Une seule rangée : un bouton par combinaison que tu as choisie dans
   les blocs. Le libellé est libre — « Or étoilé » plutôt que
   « Or / Étoiles » — et la variante reste résolue sur le produit. */
/* ══════════════════════════════════════════════════════════════
   Deux rangées, construites depuis les variantes en stock :
     rangée 1 — la couleur      (option 1 du produit)
     rangée 2 — le motif        (option 2, filtré sur la couleur)
   Rien à saisir : tout vient du produit Shopify.
   ══════════════════════════════════════════════════════════════ */
var ICO_MOTIF={
  etoiles:'<svg class="cl-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3L2.9 9.5l6.3-.9z"/></svg>',
  coeurs:'<svg class="cl-i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-8.5-5.2-8.5-11.3A4.9 4.9 0 0 1 12 6.6a4.9 4.9 0 0 1 8.5 3.1C20.5 15.8 12 21 12 21z"/></svg>'
};
function icoMotif(m){
  var k=norm(m).replace(/[éè]/g,'e').replace(/œ/g,'oe');
  if(k.indexOf('etoile')===0) return ICO_MOTIF.etoiles;
  if(k.indexOf('coeur')===0) return ICO_MOTIF.coeurs;
  return '';
}
function rCouls(){
  /* une couleur dont toutes les variantes sont épuisées n'est pas proposée ;
     elle revient d'elle-même quand le stock est remis */
  var vus=[], couls=[];
  COULEURS.forEach(function(c){
    if(vus.indexOf(c.nom)>=0)return;
    if(!COULEURS.some(function(x){ return x.nom===c.nom && x.dispo!==false; }))return;
    vus.push(c.nom); couls.push(c);
  });
  $('couls').innerHTML=couls.map(function(c){
    var on=c.nom===S.couleur.nom;
    /* 02/11/2026 : carte avec l'image du maillon et le prix du bracelet */
    var bl=blocPour(c.nom,'')||c, vv=variantePour(c.nom, (on?S.motif:'')), im=bl.img||c.img||'';
    var pr=vv&&vv.prix?vv.prix:c.prix;
    return '<button type="button" class="cl cl--card'+(on?' on':'')+'" aria-pressed="'+on+'" data-cn="'+encodeURIComponent(c.nom)+'">'+
      '<span class="cl-im'+(im?'':' cl-im--'+(c.ton==='ar'?'ar':'or'))+'">'+(im?'<img src="'+im+'" alt="" width="40" height="34" loading="lazy">':'')+'</span>'+
      '<span class="cl-tx"><span class="cl-n">'+c.nom+'</span>'+(pr?'<span class="cl-pr">'+eur(pr)+'</span>':'')+'</span></button>';}).join('');
  $('coulsT').textContent=tr('couleurLbl');

  var mots=COULEURS.filter(function(c){ return c.nom===S.couleur.nom && c.motif; });
  /* 27/10/2026 : un motif épuisé n'est plus proposé barré « 0 en stock » :
     il disparaît, et si le motif courant est épuisé on bascule sur le
     premier disponible. */
  /* 01/11/2026 : on affiche de nouveau tous les motifs ; un motif épuisé reste visible, grisé, avec son badge. */
  if(mots.length && !mots.some(function(c){ return c.motif===S.motif; })){ S.motif=mots[0].motif; majCouleur(); }
  var m=$('motifs');
  $('motifsL').hidden = mots.length<2;
  $('motifsT').textContent=tr('motifLbl');
  m.innerHTML = mots.length<2 ? '' : mots.map(function(c){
    var v=variantePour(c.nom, c.motif), ok=!v || v.dispo!==false, on=c.motif===S.motif;
    return '<button type="button" class="cl cl--m'+(on?' on':'')+(ok?'':' cl--off')+'" aria-pressed="'+on+'"'+
      (ok?'':' disabled aria-label="'+c.motif+', '+tr('motifEpuise')+'"')+
      ' data-mo="'+encodeURIComponent(c.motif)+'">'+
      (ok?icoMotif(c.motif):'')+'<span class="cl-n">'+c.motif+'</span>'+
      (ok?'':'<span class="cl-stock" aria-hidden="true">'+tr('motifEpuise')+'</span>')+'</button>';}).join('');
  /* chaque couleur a la largeur d'un motif : 2 couleurs sur 3 motifs
     tombent pile au milieu des séparations Classique|Étoiles|Cœurs */
  var nm=mots.length>=2 ? mots.length : 0;
  $('couls').style.width = '';
  /* phrase « 8 clientes sur 10… » retirée : plus d'air autour du sélecteur */
  $('clnote').textContent='';
  $('clnote').hidden=true;
}

function railHTML(total,pas,G,poses,mini){
  var o={},lc={};
  poses.forEach(function(p){cases(p.type,p.start).forEach(function(c){o[c]=1;});
    if(p.type==='chaine3'||p.type==='chaine4')for(var k=p.start+1;k<p.start+portee(p.type)-1;k++)lc[k]=1;});
  /* Premier emplacement libre : on le signale en permanence pour que la
     cliente sache toujours où son prochain charm va se poser. */
  var prochain=-1;
  for(var k2=0;k2<CFG.max&&prochain<0;k2++) if(!o[k2]) prochain=k2;
  var rail='';
  for(var i=0;i<total;i++){
    /* chaque maillon libre porte son ancrage, masqué tant qu'on ne
       glisse pas un charm au-dessus */
    var repere = (!mini && !o[i]) ? '<i class="mk"></i>' : '';
    var cl = o[i] ? ' pris' : '';
    rail+='<div class="mv '+(S.couleur.ton==='ar'?'metal-ar':'metal-or')+cl+(S.couleur.img?' img':'')+'"'+
      (mini?'':' data-i="'+i+'"')+'>'+repere+
      (S.couleur.img?'<img src="'+S.couleur.img+'" alt="" onerror="this.parentNode.classList.remove(\'img\');this.remove()">':'')+'</div>';
  }
  var couche=poses.map(function(p){var n=portee(p.type);
    var acc = mini ? '' : ' tabindex="0" role="button" aria-pressed="'+(sel===p.uid)+'" aria-label="'+
      tr('maillonN',{nom:(p.nom||''),n:(p.start+1)}).replace(/"/g,'&quot;')+'"';
    return '<div class="pose '+p.type+(sel===p.uid&&!mini?' on':'')+(neuf===p.uid?' neuf':'')+'" data-u="'+p.uid+'"'+acc+
      ' style="left:'+(p.start*pas)+'px;width:'+(G+(n-1)*pas)+'px"><img src="'+p.img+'" alt=""></div>';}).join('');
  return '<div class="rail">'+rail+'<div class="couche" style="width:'+(G+(total-1)*pas)+'px">'+couche+'</div></div>';
}
/* Le rail est redessiné à chaque changement : on rend le focus au charm
   qui l'avait, sinon le clavier repart en haut de la page. */
function refocus(uid){
  if(!uid)return;
  var el=document.querySelector('#piste .pose[data-u="'+uid+'"]'); if(el&&el.focus) el.focus({preventScroll:true});
}
if($('piste').addEventListener) $('piste').addEventListener('keydown',function(e){
  var el=e.target.closest&&e.target.closest('.pose'); if(!el)return;
  var p=parUid(el.dataset.u); if(!p)return;
  if(e.key==='ArrowLeft'||e.key==='ArrowRight'){
    e.preventDefault();
    var pas=e.key==='ArrowLeft'?-1:1, ns=p.start+pas;
    if(ns<0||ns>=CFG.max)return;
    /* voisin d'un seul maillon : on échange les deux charms */
    var voisin=null;
    S.pose.forEach(function(q){ if(q.uid!==p.uid && cases(q.type,q.start).indexOf(ns)>=0) voisin=q; });
    if(voisin && portee(p.type)===1 && portee(voisin.type)===1){
      var t0=p.start; p.start=voisin.start; voisin.start=t0;
    } else {
      while(ns>=0&&ns<CFG.max&&!libre(p.type,ns,p.uid)) ns+=pas;
      if(ns<0||ns>=CFG.max)return;
      p.start=ns;
    }
    sel=p.uid; rPiste(); refocus(p.uid); toast(tr('maillonN',{nom:p.nom,n:p.start+1}));
  } else if(e.key==='Delete'||e.key==='Backspace'){
    e.preventDefault(); retirer(p.uid);
    var reste=document.querySelector('#piste .pose'); if(reste) reste.focus(); else if($('q').focus) $('q').focus();
  } else if(e.key==='Enter'||e.key===' '){
    e.preventDefault(); sel=(sel===p.uid)?null:p.uid; S.cible=null; rPiste(); refocus(p.uid);
  } else if(e.key==='Escape'){ sel=null; rPiste(); refocus(p.uid); }
});
function rPiste(){
  /* Le bracelet de base fait 18 maillons. Chaque charm posé s'AJOUTE
     à ces 18 : 4 charms font un bracelet de 22 maillons. On plafonne
     à CFG.max pour que personne n'imagine recevoir un bracelet sans fin. */
  /* 18 maillons de base. Chaque charm REMPLACE un maillon classique ;
     au-delà de 18 charms, le bracelet s'allonge d'autant. */
  var ext=etendue();
  var total=Math.min(CFG.max, Math.max(CFG.std, ext));
  ajusterCase(total);
  var g=geo();
  $('piste').innerHTML=(!total)?'<p class="pvide">'+tr('pisteVide')+'</p>':railHTML(total,g.p,g.c,S.pose,false);
  neuf=null;
  /* nc = maillons occupés, pas nombre de charms : un double en occupe 2,
     une chaîne ancre sur 2. C'est bien la longueur du bracelet. */
  var nc=Object.keys(occ()).length;
  var detail = (nc
    ? tr('longueurDetail',{total:'<b>'+total+'</b>', ajout:'<b>'+S.pose.length+'</b> '+(S.pose.length>1?tr('charms'):tr('charm')), libres:Math.max(0,total-nc)})
    : tr('longueurBase',{std:'<b>'+CFG.std+'</b>'}));
  if(total>=CFG.max) detail += ' · <span style="color:var(--fonce)">'+tr('longueurMax')+'</span>';
  /* la couleur est déjà visible dans le sélecteur : on n'affiche que la longueur */
  $('info').innerHTML=detail;
  $('vider').hidden=S.pose.length===0;
  /* 01/11/2026 : le choix « avec / sans bracelet » disparaît du visualisateur dès qu'il est fait (ou dès le premier charm) ; il reste modifiable dans le volet de la barre du bas */
  var e=$('edit'),p=sel?parUid(sel):null;
  if(p){e.classList.add('on');$('editn').textContent=p.nom;} else e.classList.remove('on');
  ajusterBas();
  persister();
}
/* La place sous le bracelet suit ce qui pend vraiment : une chaîne
   longue descend bien plus bas qu'un pendentif. On mesure les images
   posées au lieu de réserver une hauteur fixe qui finissait par rogner
   les grandes chaînes. */
function ajusterBas(){
  var el=document.getElementById('piste'); if(!el)return;
  var rail=el.querySelector('.rail'); if(!rail){ el.style.paddingBottom=''; return; }
  var rr=rail.getBoundingClientRect(), bas=0;
  Array.prototype.forEach.call(el.querySelectorAll('.pose img'),function(im){
    if(!im.complete||!im.naturalWidth)return;
    var r=im.getBoundingClientRect(); bas=Math.max(bas, r.bottom-rr.bottom);
  });
  var mini = window.innerWidth<720 ? 24 : 32;
  el.style.paddingBottom = Math.ceil(Math.max(mini, bas+14)) + 'px';
}
if($('piste').addEventListener) $('piste').addEventListener('load',function(e){
  if(e.target && e.target.tagName==='IMG') ajusterBas();
},true);
function compte(id){return S.pose.filter(function(p){return p.pid===id;}).length;}
function compatible(c){
  /* 02/11/2026 : charm à plusieurs couleurs (or / argent) : la carte reste visible tant
     qu'UNE de ses variantes va avec le bracelet — choisir l'argenté ne la fait plus disparaître */
  if(c.el && c.el.querySelectorAll){
    var sws=c.el.querySelectorAll('.bb2-charm-swatch');
    if(sws.length>1){ for(var i=0;i<sws.length;i++){ var mm=METAL[norm(sws[i].dataset.couleur||'')]; if(!mm||mm===S.couleur.ton) return true; } return false; }
  }
  var m=METAL[norm(c.couleur)];if(!m)return true;return m===S.couleur.ton;}
function rCats(){$('cats').innerHTML=CATS.map(function(c){
  return '<button class="cat'+(c.id===S.cat?' on':'')+'" data-cat="'+c.id+'">'+c.n+'</button>';}).join('');}
function rGrille(){
  var q=sansAccent(norm(S.q)), vus=0, affiches=0;
  /* Dès qu'on filtre, on montre TOUS les résultats : la recherche doit
     trouver le 482e charm comme le premier. */
  var limiteVive = Infinity;
  DATA.charms.forEach(function(c){
    var ok=true;
    if(S.cat==='best'){ if(BEST.indexOf(String(c.id))<0)ok=false; }
    else if(S.cat==='new'){ if(NOUV.indexOf(String(c.id))<0)ok=false; }

    else if(S.cat!=='tous'&&c.cats.indexOf(','+S.cat+',')<0)ok=false;
    if(ok&&!compatible(c))ok=false;
    if(ok&&q&&(c.cherche||sansAccent(c.nom+' '+c.couleur+' '+c.tags)).indexOf(q)===-1)ok=false;
    var cache=false;
    if(ok){ vus++; if(affiches<limiteVive){ affiches++; } else cache=true; }
    else cache=true;
    /* on n'écrit dans la page que ce qui change : un clic ne réécrit plus
       les ~490 cartes, seulement celle qui bouge */
    if(c._h!==cache){ c._h=cache; c.el.hidden=cache; }
    var n=compte(c.id);
    if(c._n!==n){
      c._n=n;
      c.el.classList.toggle('is-added', n>0);
      if(c.elN) c.elN.textContent=n;
      if(c.elQty) c.elQty.style.display=n>0?'flex':'none';
    }
    var co=c.elCo;
    if(co){ var w=S.wish.indexOf(String(c.id))>=0;
      if(c._w!==w){ c._w=w; co.classList.toggle('on',w); co.textContent=w?'♥':'♡';
        co.setAttribute('aria-pressed', w?'true':'false'); } }
  });
  rEncarts(affiches);
  /* pendant le chargement du catalogue, pas de « aucun résultat » prématuré */
  $('aucun').hidden = vus>0 || (suiteLancee && !suiteFinie);
  $('plusbtn').hidden = true;
  /* 27/10/2026 : tant que le reste du catalogue n'est pas chargé, on ne
     montre pas « 54 charms » (c'était le nombre de la première page). */
  var pagesTot=parseInt(CFGS.pages||1,10);
  $('compte').innerHTML = (pagesTot>1 && !suiteFinie) ? '' : (vus ? (vus + ' ' + (vus>1 ? tr('charms') : tr('charm'))) : '');
}
/* 27/10/2026 : ordre de la grille — best-sellers d'abord, puis le reste,
   puis les épuisés, et les cartes « lettres / mois » (modale) en dernier.
   Tri stable, puis les cartes sont ré-insérées dans la grille dans cet ordre. */
/* 01/11/2026 : on respecte l'ordre de la collection Shopify ; les épuisés restent à leur place (grisés) */
function rangDe(c){
  if(c.modale) return 3;
  return 1;
}
function ordonner(){
  var g=$('grille'); if(!g||!g.appendChild||!DATA.charms.length) return;
  var idx=DATA.charms.map(function(c,i){ return {c:c,i:i,r:rangDe(c)}; });
  idx.sort(function(a,b){ return a.r-b.r || a.i-b.i; });
  var frag=document.createDocumentFragment();
  idx.forEach(function(x){ frag.appendChild(x.c.el); });
  g.appendChild(frag);
  DATA.charms=idx.map(function(x){ return x.c; });
  encartsCle='';
}
/* Encarts insérés dans la grille : la cliente croise un avis ou une
   preuve pendant qu'elle fait défiler, au moment où elle est engagée. */
var encartsCle='';
var encRz=null; window.addEventListener('resize',function(){ clearTimeout(encRz); encRz=setTimeout(function(){ try{ rGrille(); }catch(e){} },250); });
function rEncarts(affiches){
  var g=$('grille'); if(!g||!g.querySelectorAll)return;
  /* mêmes filtres, même nombre de cartes : les encarts sont déjà à leur place */
  /* 02/11/2026 : un bandeau toutes les 2 rangées complètes (3 colonnes → 6, 5 colonnes → 10) */
  var cols=0; try{ cols=(getComputedStyle(g).gridTemplateColumns||'').split(' ').filter(Boolean).length; }catch(e){}
  var cle=S.cat+'|'+S.q+'|'+affiches+'|'+DATA.charms.length+'|'+cols;
  if(cle===encartsCle && g.querySelector('.encart')) return;
  encartsCle=cle;
  Array.prototype.forEach.call(g.querySelectorAll('.encart'),function(e){e.remove();});
  var pas=parseInt(CFGS.encartTous||0,10);
  if(pas && cols>1) pas=cols*2;
  if(!pas||affiches<pas)return;
  var src=document.getElementById('encarts-source');
  if(!src)return;
  var brut=Array.prototype.slice.call(src.children);
  if(!brut.length)return;
  /* Alternance preuve / avis, faite ici plutôt qu'en Liquid. */
  var pv=brut.filter(function(e){return e.dataset.ordre==='pv';});
  var av=brut.filter(function(e){return e.dataset.ordre!=='pv';});
  var pool=[];
  for(var z=0; z<Math.max(pv.length,av.length); z++){
    if(pv[z]) pool.push(pv[z]);
    if(av[z]) pool.push(av[z]);
  }
  var visibles=DATA.charms.filter(function(c){return !c.el.hidden;});
  var k=0;
  for(var i=pas-1;i<visibles.length && k<pool.length;i+=pas){
    /* Chaque encart n'apparaît QU'UNE FOIS. Avec un seul avis en base,
       on le voyait se répéter toutes les 6 cartes. */
    var e=pool[k].cloneNode(true); k++;
    var ap=visibles[i].el;
    if(ap.nextSibling) g.insertBefore(e,ap.nextSibling); else g.appendChild(e);
  }
}

/* 01/11/2026 : en mode « j'en ai déjà un », le bracelet est quand même offert dès 10 charms */
function avecBracelet(){ return S.mode==='first' || (CFG.braceletOffertA>0 && S.pose.length>=CFG.braceletOffertA); }
function totaux(){
  var nb=S.pose.length, brut=S.pose.reduce(function(s,p){return s+p.prix;},0), ch=brut;
  var brac=0,bo=false,deg=false,remDeg=0;
  if(CFG.degressifA>0&&nb>=CFG.degressifA){deg=true;remDeg=Math.round(brut*CFG.degressifPct/100);ch=brut-remDeg;}
  if(S.mode==='first'){bo=nb>=CFG.braceletOffertA;brac=bo?0:(S.couleur.prix||0);}
  else if(CFG.braceletOffertA>0 && nb>=CFG.braceletOffertA){bo=true;brac=0;}
  /* Bracelets en plus (payants) : ajoutés avec le + de la ligne bracelet. */
  var brx=avecBracelet()?brxListe().reduce(function(a,c){return a+(c.prix||0);},0):0;
  var ou=S.outil?CFG.prixOutil:0,sous=brac+ch+ou+brx,lo=sous>=CFG.livDes;
  return{nb:nb,brut:brut,brx:brx,sous:sous,bo:bo,deg:deg,remDeg:remDeg,lo:lo,total:sous+(lo?0:CFG.liv)};
}
/* ── 02/11/2026 : maquette v4 ──
   Barre de progression façon Paalm (dégradé rose, curseur, jalons) et
   panneau « Ta sélection » avec −/+. Les jalons sont une liste : on
   pourra y ajouter les paliers Black Friday sans toucher au reste. */
var v4Ouvert=false;
function brPrixPlein(){ return avecBracelet() ? (S.couleur.prix||0) : 0; }
/* Nombre de charms à partir duquel la livraison devient offerte : on
   rejoue le calcul de totaux() charm par charm (les charms posés d'abord,
   puis des charms au prix moyen). */
function v4LivActive(){ return CFG.livDes>0 && CFG.livDes<9999900; }
function v4NbLiv(){
  if(!v4LivActive()) return -1;
  var prix=S.pose.map(function(p){return p.prix;});
  var moy=prix.length ? Math.round(prix.reduce(function(a,b){return a+b;},0)/prix.length) : 499;
  if(!(moy>0)) moy=499;
  var ou=S.outil?CFG.prixOutil:0, cum=0;
  for(var i=0;i<=60;i++){
    if(i>0) cum += (i<=prix.length ? prix[i-1] : moy);
    var ch=cum; if(CFG.degressifA>0&&i>=CFG.degressifA) ch=cum-Math.round(cum*CFG.degressifPct/100);
    var brac=0;
    if(S.mode==='first' && !(CFG.braceletOffertA>0 && i>=CFG.braceletOffertA)) brac=S.couleur.prix||0;
    if(brac+ch+ou>=CFG.livDes) return i;
  }
  return -1;
}
function v4Jalons(){
  var max=CFG.braceletOffertA>0?CFG.braceletOffertA:10, t=totaux(), J=[];
  if(CFG.degressifA>0 && CFG.degressifA<max) J.push({n:CFG.degressifA,l:'−'+CFG.degressifPct+' %',ok:t.deg});
  var nl=v4NbLiv(), brMax=max;
  if(nl>0 && nl<max) J.push({n:nl,l:tr('v4MLiv'),ok:t.lo,liv:true});
  /* 02/11/2026 : « J'ai le mien » — sans le prix du bracelet, la livraison offerte arrive
     après le 10e charm : la barre s'allonge jusqu'à elle au lieu de la masquer. */
  if(nl>=max && nl-max<=3){
    /* paliers trop proches pour deux étiquettes : une seule, en fin de barre */
    J.push({n:max,l:'',ok:t.bo});
    J.push({n:nl,l:tr('v4MBr',{n:max})+'<br>+ '+String(tr('v4MLiv')).replace(/<br\s*\/?>/i,' '),ok:t.lo&&t.bo,liv:true,fin:true});
    max=nl;
  } else if(nl>max){
    J.push({n:max,l:tr('v4MBr',{n:max}),ok:t.bo});
    J.push({n:nl,l:tr('v4MLiv'),ok:t.lo,liv:true,fin:true});
    max=nl;
  } else J.push({n:max,l:tr('v4MBr',{n:max}),ok:t.bo,fin:true});
  return {max:max,brMax:brMax,j:J,t:t,nl:nl};
}
function hBarre(){
  var d=v4Jalons(), t=d.t, max=d.max, nb=t.nb;
  var p=Math.max(0,Math.min(100,nb/max*100));
  var gros, droite;
  if(t.bo){ gros=tr('v4BrOk');
    droite = (t.lo||!v4LivActive()) ? tr('v4Tout') : tr('v4EncoreLiv',{x:eur(Math.max(1,CFG.livAff-t.sous))}); }
  else { gros=tr(nb>1?'v4N':'v4N1',{n:nb}); droite=tr('v4Encore',{n:Math.max(1,(d.brMax||max)-nb)}); }
  var ticks='', lbls='';
  d.j.forEach(function(j){
    var x=j.n/max*100;
    if(!j.fin) ticks+='<span class="pb-tk" style="left:'+x+'%"></span>';
    /* deux étiquettes trop proches se chevaucheraient : on ne garde que la dernière */
    if(!j.fin && (x>74 || !j.l)) return;
    lbls+='<span class="pb-l'+(j.ok?' ok':'')+(j.fin?' pb-l--fin':'')+'"'+(j.fin?'':' style="left:'+x+'%"')+'>'+j.l+'</span>';
  });
  return '<div class="pb-h"><span class="pb-n">'+gros+'</span><span class="pb-r">'+droite+'</span></div>'+
    '<div class="pb-t" role="progressbar" aria-valuemin="0" aria-valuemax="'+max+'" aria-valuenow="'+Math.min(nb,max)+'">'+
      '<span class="pb-f" style="width:'+p+'%"></span>'+ticks+
      '<span class="pb-k" style="left:calc((100% - var(--pbk,26px)) * '+(p/100)+')"><i></i></span></div>'+
    '<div class="pb-ls">'+lbls+'</div>';
}
function v4Groupes(){
  var g={},ord=[];
  S.pose.forEach(function(p){var k=p.vid+'|'+p.nom;if(!g[k]){g[k]={p:p,n:0,u:p.uid};ord.push(k);}g[k].n++;g[k].u=p.uid;});
  return ord.map(function(k){return g[k];});
}
function hItems(){
  /* En mode « premier bracelet », le bracelet est toujours dans la
     sélection, même sans charm posé. */
  if(!S.pose.length&&!S.outil&&S.mode!=='first')return '<p class="vhint">'+tr('videRecap')+'</p>';
  var t=totaux(),h='';
  if(avecBracelet())h+='<div class="it it--br'+(t.bo?' free':'')+'"><span class="it-v">'+((S.couleur.photo||S.couleur.img)?'<img src="'+(S.couleur.photo||S.couleur.img)+'" alt="" width="44" height="44">':'')+'</span>'+
    '<span class="it-n"><b>'+tr('braceletLbl',{couleur:S.couleur.nom.toLowerCase()})+
    ((S.motif&&!/^(classique|simple|basique)$/i.test(S.motif))?' · '+S.motif.toLowerCase():'')+'</b><small>'+(t.bo?'<s>'+eur(S.couleur.prix||0)+'</s> · '+tr('offert').toLowerCase():eur(S.couleur.prix||0))+'</small></span>'+
    '<span class="it-q"><button type="button" data-brm'+(S.brx.length?'':' disabled')+' aria-label="'+tr('v4Moins')+' : '+tr('bracelet')+'">−</button><span>'+(1+S.brx.length)+'</span>'+
    '<button type="button" data-brp'+(S.brx.length>=BR_MAX-1?' disabled':'')+' aria-label="'+tr('v4Plus')+' : '+tr('bracelet')+'">+</button></span>'+
    ''+'</div>';
  if(avecBracelet()) brxListe().forEach(function(c,i){
    var nomB=tr('bracelet'); nomB=nomB.charAt(0).toUpperCase()+nomB.slice(1)+' '+(i+2);
    var im=c.photo||c.img;
    h+='<div class="it it--brx"><span class="it-v">'+(im?'<img src="'+im+'" alt="" width="44" height="44">':'<i class="brx-d" style="background:'+c.rond+'"></i>')+'</span>'+
      '<span class="it-n"><b>'+nomB+' · '+(c.libelle||c.nom).toLowerCase()+'</b><small>'+eur(c.prix||0)+'</small></span><span class="brx-c">'+
      brChoix().map(function(o){ var oi=o.photo||o.img; return '<button type="button" data-brc="'+i+'|'+o.id+'" aria-pressed="'+(o.id===c.id?'true':'false')+'" title="'+(o.libelle||o.nom)+'">'+(oi?'<img src="'+oi+'" alt="" width="40" height="40" loading="lazy">':'<i style="background:'+o.rond+'"></i>')+'<span>'+(o.libelle||o.nom)+'</span></button>'; }).join('')+
      '</span></div>';
  });
  var G=v4Groupes(), lim=3, cache=(!v4Ouvert && G.length>lim+1) ? G.length-lim : 0;
  G.forEach(function(o,i){
    var nomA=o.p.nom.replace(/"/g,'&quot;');
    h+='<div class="it'+(cache&&i>=lim?' it--cache':'')+'"><span class="it-v"><img src="'+(o.p.photo||o.p.img)+'" alt="" width="44" height="44"></span>'+
      '<span class="it-n"><b>'+o.p.nom+'</b><small>'+eur(o.p.prix)+'</small></span>'+
      '<span class="it-q"><button type="button" data-moins="'+o.u+'" aria-label="'+tr('v4Moins')+' : '+nomA+'">−</button><span>'+o.n+'</span>'+
      '<button type="button" data-plus="'+o.u+'" aria-label="'+tr('v4Plus')+' : '+nomA+'">+</button></span></div>';});
  if(cache) h+='<button type="button" class="it-plus" data-v4tout>'+tr('v4Autres',{n:cache})+' '+(cache>1?tr('charms'):tr('charm'))+'</button>';
  if(S.outil)h+='<div class="it"><span class="it-v">🔧</span><span class="it-n"><b>'+((CFGS.outil&&CFGS.outil.titre)||'Outil à charms')+'</b><small>'+eur(CFG.prixOutil)+'</small></span>'+
    '<button class="it-x" type="button" data-sup="__o" aria-label="'+tr('retirerOutil').replace(/"/g,'&quot;')+'">×</button></div>';
  return h;
}
function hMsg(){
  var t=totaux(), max=CFG.braceletOffertA;
  if(!(max>0)) return '';
  if(t.bo) return (t.lo&&v4LivActive()) ? tr('v4MsgTout') : tr('v4MsgBr');
  var r=max-t.nb; return tr('v4MsgEncore',{n:r+' '+(r>1?tr('charms'):tr('charm'))});
}
function hTot(){var t=totaux();if(!t.nb&&!S.outil&&S.mode!=='first')return'';
  var brp=brPrixPlein(), sousBrut=t.brut+brp+(t.brx||0)+(S.outil?CFG.prixOutil:0), eco=0, h='';
  h+='<div class="tl"><span>'+tr('v4SousTotal')+'</span><span>'+eur(sousBrut)+'</span></div>';
  if(t.deg){ eco+=t.remDeg; h+='<div class="tl free"><span>'+tr('remiseDes',{pct:CFG.degressifPct,n:CFG.degressifA})+'</span><span>−'+eur(t.remDeg)+'</span></div>'; }
  if(t.bo && brp){ eco+=brp; h+='<div class="tl free"><span>'+tr('v4BrOk')+' <em>−'+eur(brp)+'</em></span><span>−'+eur(brp)+'</span></div>'; }
  if(v4LivActive()){
    var pl=Math.min(100,t.sous/CFG.livDes*100);
    h+='<div class="tl tl-liv'+(t.lo?' free':'')+'"><span>'+(t.lo?tr('v4LivOk'):tr('v4LivNo',{seuil:eur(CFG.livAff)}))+'</span>'+
       '<span class="tl-lb"><i style="width:'+pl+'%"></i></span></div>';
  } else h+='<div class="tl tl-liv"><span>'+tr('livDe',{seuil:eur(CFG.livAff)})+'</span></div>';
  h+='<div class="tm"><span>'+tr('total')+(eco>0?'<small>'+tr('v4Eco',{x:eur(eco)})+'</small>':'')+'</span><b>'+eur(t.sous)+'</b></div>';
  return h;}
function v4Cta(l,prix){
  return '<span class="cta-l">'+l+'</span>'+(prix?'<span class="cta-p">'+prix+'</span>':'');
}
function rRecap(){
  var t=totaux();
  var bar=hBarre();
  ['pb','mpb'].forEach(function(i){ $(i).innerHTML=bar; });
  var msg=hMsg();
  ['dmsg','mmsg'].forEach(function(i){ $(i).innerHTML=msg; if($(i).hidden!==undefined) $(i).hidden=!msg; });
  ['items','mitems'].forEach(function(i){$(i).innerHTML=hItems();});
  ['tot','mtot'].forEach(function(i){$(i).innerHTML=hTot();});
  /* Détail complet de la sélection : bracelet, charms, outil. */
  var bouts=[];
  /* en allemand, les noms gardent leur majuscule */
  var bas=function(x){ return /^de/i.test(CFGS.locale||'') ? x : x.toLowerCase(); };
  if(avecBracelet()) bouts.push((1+S.brx.length)+' '+bas(tr('bracelet'))+((S.brx.length&&!/^de/i.test(CFGS.locale||''))?'s':''));
  if(t.nb) bouts.push(t.nb+' '+(t.nb>1?tr('charms'):tr('charm')));
  if(S.outil) bouts.push('1 '+bas((CFGS.outil&&CFGS.outil.titre)||'outil'));
  var txt = bouts.join(' + ');
  ['sc','dsc'].forEach(function(i){ $(i).textContent = txt; });
  var v=(t.nb===0&&!S.outil&&S.mode!=='first');
  ['cta','mcta'].forEach(function(i){$(i).disabled=v;$(i).innerHTML=v4Cta(tr('valider'), v?'':eur(t.sous));});
  if($('svider').disabled!==undefined) $('svider').disabled = (t.nb===0 && !S.outil);
  /* rRecap est appelée à chaque changement d'état, contrairement à rendre :
     c'est ici que la pastille « Mon bracelet » doit se mettre à jour. */
  rSel();
  persister();
  if(window.BB3_MAJ_H)window.BB3_MAJ_H();
  if(BR_MAJ)BR_MAJ();
}
/* −/+ sur une ligne de la sélection */
function v4PlusUn(uid){
  var p=parUid(uid); if(!p)return;
  var o=occ();
  if(Object.keys(o).length + portee(p.type) > CFG.max){ toast(tr('longueurAtteinte')); return; }
  var memes=S.pose.filter(function(x){return x.vid===p.vid && x.nom===p.nom;}).length;
  if(p.qte!==null && p.qte!==undefined && !isNaN(p.qte) && !p.sfx && memes>=Math.max(0,p.qte)){
    toast(p.qte>0 ? tr('stockMax',{n:p.qte}) : tr('epuise')); return; }
  var s=place(p.type,o); if(s<0){ toast(tr('plusDePlace')); return; }
  var q={}; Object.keys(p).forEach(function(k){q[k]=p[k];});
  q.uid='u'+(++seq); q.start=s;
  S.pose.push(q); neuf=q.uid; sel=null; videAnnulable=null;
  rPiste();rGrille();rRecap();persister();
}
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-moins],[data-plus],[data-v4tout],[data-brp],[data-brm],[data-brc]'); if(!b)return;
  if(!b.closest('.bb3'))return;
  if(b.hasAttribute('data-brp')){ if(S.brx.length<BR_MAX-1) S.brx.push(S.couleur.id); rRecap(); persister(); return; }
  if(b.hasAttribute('data-brm')){ S.brx.pop(); rRecap(); persister(); return; }
  if(b.hasAttribute('data-brc')){ var pc=b.getAttribute('data-brc').split('|'); if(brCoul(pc[1])) S.brx[+pc[0]]=pc[1]; rRecap(); persister(); return; }
  if(b.hasAttribute('data-v4tout')){ v4Ouvert=true; rRecap(); return; }
  if(b.hasAttribute('data-moins')){ retirer(b.getAttribute('data-moins'),true); return; }
  v4PlusUn(b.getAttribute('data-plus'));
});
/* Bande de sélection : les charms posés en miniature, sous la jauge,
   toujours visibles sans déplier le panneau. */
function rSel(){
  var el=$('selstrip'); if(!el||el.hidden===undefined)return;
  if(!S.pose.length && S.mode!=='first'){ el.hidden=true; el.innerHTML=''; return; }
  el.hidden=false;
  /* Première vignette : le bracelet lui-même, dans sa couleur, pour
     qu'on voie tout de suite ce qu'on emporte. Pas de noms sous les
     charms, la bande doit rester légère. */
  var h='';
  if(S.mode==='first'){
    h+='<div class="sel sel--br" title="'+S.couleur.nom+'">'+
       /* la vraie photo de la variante choisie, pas un maillon générique */
       (S.couleur.photo?'<img src="'+S.couleur.photo+'" alt="">'
        :(S.couleur.img?'<img src="'+S.couleur.img+'" alt="">'
                       :'<span class="sel-br '+(S.couleur.ton==='ar'?'ar':'or')+'"></span>'))+
       '</div>';
  }
  h+=ordre().map(function(p){
    return '<div class="sel" data-suid="'+p.uid+'" title="'+p.nom+'">'+
      '<img src="'+(p.photo||p.img)+'" alt="'+p.nom+'">'+
      '<button class="sel-x" type="button" data-selx="'+p.uid+'" aria-label="'+tr('retirerX',{nom:p.nom}).replace(/"/g,'&quot;')+'">×</button>'+
      '</div>';}).join('');
  el.innerHTML=h;
}

function rWish(){
  var n=S.wish.length;
  $('wbar').hidden=n===0; $('wlist').hidden=n===0; $('wn').textContent=n;
  /* On vide vraiment la liste : « hidden » ne suffit pas, la règle
     display:flex du conteneur le neutralise et les vignettes restaient
     visibles alors que la liste était comptée à zéro. */
  if(!n) $('wlist').innerHTML='';
  var mot=$('wmot'); if(mot&&mot.textContent!==undefined) mot.textContent = n>1 ? tr('charms') : tr('charm');
  if(!n)return;
  $('wlist').innerHTML=S.wish.map(function(id){var c=charm(id);if(!c)return'';
    return '<div class="wl" data-w="'+id+'"><img src="'+(c.photo||c.img)+'" alt="">'+
      '<button class="wl-x" data-wx="'+id+'" aria-label="'+tr('retirerListe').replace(/"/g,'&quot;')+'">×</button>'+
      '<span>'+c.nom+'</span></div>';}).join('');
}
function rendre(){rCouls();rBracelet();rPiste();rCats();rGrille();rRecap();rWish();persister();}

/* ── actions ── */
function ajouter(c,extra){
  videAnnulable=null;
  var o=occ();
  if(Object.keys(o).length + portee(c.type) > CFG.max){
    toast(tr('longueurAtteinte'));
    return;
  }
  if(c.suivi && c.qte!==null && !isNaN(c.qte) && !(extra&&extra.sfx) && compte(c.id)>=Math.max(0,c.qte)){
    toast(c.qte>0 ? tr('stockMax',{n:c.qte}) : tr('epuise'));
    return;
  }
  var s=-1;
  /* Si la cliente a choisi un maillon, on pose là. Sinon, premier libre. */
  if(S.cible!==null&&cases(c.type,S.cible).every(function(x){return !o[x]&&x<CFG.max;}))s=S.cible;
  if(s<0)s=place(c.type,o);
  if(s<0){toast(tr('plusDePlace'));return;}
  S.cible=null;
  /* img = image calibrée pour le rail (un pendentif déborde sur 3 cases).
     photo = visuel produit carré, celui qu'on montre partout ailleurs. */
  var p={uid:'u'+(++seq),pid:c.id,vid:c.vid||c.id,nom:c.nom+(extra&&extra.sfx?' — '+extra.sfx:''),
    type:c.type,prix:c.prix,img:c.img,photo:c.photo||c.img,start:s,
    sfx:(extra&&extra.sfx)||null,sfxCle:(extra&&extra.cle)||null};
  /* Lettre : on pose la variante de la lettre choisie, avec sa propre photo */
  if(p.sfx&&c.vars){
    var lv=c.vars.filter(function(x){return x.t===p.sfx;})[0];
    if(lv){ p.vid=lv.id; p.vexacte=true; if(lv.img){ p.img=lv.img; p.photo=lv.img; } }
  }
  /* 01/11/2026 : charm à plusieurs couleurs → le nom de la couleur suit, pour que la sélection
     distingue « Soleil avec pierre — Vert » de « Soleil avec pierre — Blanc » */
  if(!p.sfx && c.el && c.el.querySelectorAll){
    var sws=c.el.querySelectorAll('.bb2-charm-swatch'), act=c.el.querySelector('.bb2-charm-swatch.is-active');
    if(sws.length>1 && act && act.dataset.couleur) p.nom=c.nom+' — '+act.dataset.couleur;
  }
  if(c.suivi && c.qte!==null && c.qte!==undefined && !isNaN(c.qte)) p.qte=+c.qte;
  S.pose.push(p);neuf=p.uid;sel=null;
  rPiste();rGrille();rRecap();persister();
  /* On ne touche pas au défilement de la page : seule la piste se recale,
     horizontalement, et seulement si le charm posé sort du cadre. */
  var piste=$('piste'), el=piste.querySelector?piste.querySelector('[data-u="'+p.uid+'"]'):null;
  if(el&&piste.scrollWidth>piste.clientWidth){
    var g=geo(), x=el.offsetLeft, w=el.offsetWidth;
    if(x<piste.scrollLeft || x+w>piste.scrollLeft+piste.clientWidth){
      piste.scrollTo({left:Math.max(0,x-(piste.clientWidth-w)/2),behavior:'smooth'});
    }
  }
}
function retirer(u,muet){
  videAnnulable=null;
  var i=-1;for(var k=0;k<S.pose.length;k++)if(S.pose[k].uid===u){i=k;break;}
  if(i<0)return;dernier=S.pose[i];S.pose.splice(i,1);if(sel===u)sel=null;
  rPiste();rGrille();rRecap();if(!muet)toast(tr('charmRetire'),true);
}
function retirerDe(pid){for(var i=S.pose.length-1;i>=0;i--)if(S.pose[i].pid===pid){retirer(S.pose[i].uid,true);return;}}
function deplacer(sens){var p=sel?parUid(sel):null;if(!p)return;
  var ns=p.start+sens;if(!libre(p.type,ns,p.uid))return;p.start=ns;rPiste();}
var tt;function toast(t,u){$('toastt').textContent=t;$('toastb').style.display=u?'inline':'none';
  $('toast').classList.add('on');clearTimeout(tt);tt=setTimeout(function(){$('toast').classList.remove('on');},3600);}

/* Ligne bracelet : inclus par défaut, retirable en un clic.
   Elle remplace l'ancienne étape « on part de quoi ? ». */
function rBracelet(){
  qq('[data-mode]',$('brchoix')).forEach(function(x){
    x.classList.toggle('on', x.dataset.mode===S.mode);
  });
  /* 01/11/2026 : mêmes boutons dans le volet dépliable de la barre du bas */
  var sx=document.getElementById('sxp');
  if(sx) qq('[data-mode]',sx).forEach(function(x){ x.classList.toggle('on', x.dataset.mode===S.mode); });

}
if($('brchoix').addEventListener) $('brchoix').addEventListener('click',function(e){
  var b=e.target.closest('[data-mode]'); if(!b)return;
  S.choixFait=true;
  S.mode=b.dataset.mode;
  rendre();
});
/* 01/11/2026 : volet dépliable de la barre du bas (flèche) */
(function(){
  var tg=document.getElementById('shtg'), sx=document.getElementById('sxp');
  if(tg && sx){
    tg.addEventListener('click',function(){
      var o=sx.hidden; sx.hidden=!o; var sb=document.getElementById('sb'); if(sb) sb.hidden=!o;
      tg.setAttribute('aria-expanded', o?'true':'false'); tg.classList.toggle('on',o);
    });
    sx.addEventListener('click',function(e){
      var b=e.target.closest('[data-mode]'); if(!b)return;
      S.choixFait=true; S.mode=b.dataset.mode; rendre();
    });
  }
})();

$('parcours').addEventListener('click',function(e){var b=e.target.closest('[data-mode]');if(!b||S.mode===b.dataset.mode)return;
  S.mode=b.dataset.mode;qq('[data-mode]',this).forEach(function(x){x.classList.toggle('on',x.dataset.mode===S.mode);});
  rendre();});
function choisirCouleur(e){
  var mo=e.target.closest('[data-mo]');
  if(mo){
    var mm=decodeURIComponent(mo.dataset.mo), vv=variantePour(S.couleur.nom, mm);
    if(mo.disabled || (vv && vv.dispo===false)) return;
    S.motif=mm; majCouleur(); rendre(); return; }
  var n=e.target.closest('[data-cn]');
  if(!n)return;
  var nom=decodeURIComponent(n.dataset.cn);
  if(n.disabled || !COULEURS.some(function(x){ return x.nom===nom && x.dispo!==false; })) return;
  S.couleur={nom:nom};
  /* on garde le motif si la nouvelle couleur le propose */
  var dispo=COULEURS.filter(function(c){ return c.nom===nom && c.motif; });
  var garde=false;
  var enStock=function(c){ var v=variantePour(nom, c.motif); return !v || v.dispo!==false; };
  dispo.forEach(function(c){ if(c.motif===S.motif && enStock(c)) garde=true; });
  if(!garde){ var premier=dispo.filter(enStock)[0] || dispo[0]; S.motif = premier ? premier.motif : ''; }
  majCouleur(); rendre();
}
$('couls').addEventListener('click',choisirCouleur);
if($('motifs').addEventListener) $('motifs').addEventListener('click',choisirCouleur);
/* Vider se rattrape : une cliente qui touche « Vider » par erreur
   récupère tout son bracelet avec « Annuler ». */
var videAnnulable=null;
function viderTout(){
  if(!S.pose.length && !S.outil) return;
  videAnnulable={pose:S.pose.slice(), outil:S.outil};
  S.pose=[]; S.outil=false; S.brx=[]; sel=null; S.cible=null; dernier=null;
  $('outil').classList.remove('on'); $('outil').textContent=tr('ajouter');
  if($('outil').setAttribute) $('outil').setAttribute('aria-pressed','false');
  rendre();
  toast(tr('braceletVide'),true);
}
$('vider').addEventListener('click',viderTout);
/* ── Glisser-déposer : même code pour la souris et le doigt ── */
var DG={uid:null,el:null,x0:0,left0:0,bouge:false,cible:null,decal:0,origine:null,auto:0};
function indexSous(clientX){
  var rail=$('piste').querySelector('.rail'); if(!rail)return 0;
  var r=rail.getBoundingClientRect(),g=geo();
  return Math.max(0,Math.min(CFG.max-1,Math.round((clientX-r.left-g.c/2)/g.p)));
}
function marquerOrigine(){
  /* La place d'où le charm vient reste signalée pendant tout le glisser :
     sans ce repère, on croit ne plus pouvoir le remettre où il était. */
  var p = DG.uid ? parUid(DG.uid) : null;
  if(!p || DG.origine === null || DG.origine === undefined) return;
  cases(p.type, DG.origine).forEach(function(c){
    var m=$('piste').querySelector('.mv[data-i="'+c+'"]');
    if(m) m.classList.add('origine');
  });
}
function marquerCible(i){
  qq('.mv',$('piste')).forEach(function(m){m.classList.remove('drop','origine');});
  marquerOrigine();
  var p=DG.uid?parUid(DG.uid):null; if(!p)return;
  cases(p.type,i).forEach(function(c){
    var m=$('piste').querySelector('.mv[data-i="'+c+'"]');
    if(m)m.classList.add('drop');});
}
$('piste').addEventListener('pointerdown',function(e){
  var el=e.target.closest('.pose'); if(!el)return;
  var p=parUid(el.dataset.u); if(!p)return;
  DG.uid=p.uid; DG.el=el; DG.x0=e.clientX; DG.left0=parseFloat(el.style.left)||0;
  DG.bouge=false; DG.cible=p.start;
  /* On mémorise PAR OÙ le charm a été saisi. Sans ça, le maillon sous
     le doigt devient toujours l'ancre gauche : une chaîne attrapée par
     sa droite partait vers la droite. Avec ce décalage, le charm suit
     le doigt depuis le point exact où on l'a pris. */
  DG.decal = Math.max(0, Math.min(portee(p.type)-1, indexSous(e.clientX) - p.start));
  DG.origine = p.start;
  el.setPointerCapture(e.pointerId);
});
$('piste').addEventListener('pointermove',function(e){
  if(!DG.uid)return;
  var d=e.clientX-DG.x0;
  if(!DG.bouge){ if(Math.abs(d)<5)return; DG.bouge=true; DG.el.classList.add('saisi'); marquerOrigine(); }
  e.preventDefault();
  DG.el.style.left=(DG.left0+d)+'px';
  var p=parUid(DG.uid);
  var i=Math.max(0, indexSous(e.clientX) - (DG.decal||0));
  if(p&&libre(p.type,i,p.uid)){ DG.cible=i; marquerCible(i); }
  /* défilement automatique si le bracelet dépasse de l'écran */
  var pi=$('piste'),r=pi.getBoundingClientRect();
  if(pi.scrollWidth>pi.clientWidth){
    if(e.clientX>r.right-40)pi.scrollLeft+=8;
    else if(e.clientX<r.left+40)pi.scrollLeft-=8;
  }
},{passive:false});
function finDrag(){
  if(!DG.uid)return;
  var p=parUid(DG.uid);
  if(DG.bouge&&p&&DG.cible!==null&&libre(p.type,DG.cible,p.uid)){ p.start=DG.cible; sel=null; }
  else if(!DG.bouge){ sel=(sel===DG.uid)?null:DG.uid; S.cible=null; }
  if(DG.el)DG.el.classList.remove('saisi');
  qq('.mv',$('piste')).forEach(function(m){m.classList.remove('drop','origine');});
  DG.uid=null;DG.el=null;DG.bouge=false;DG.cible=null;DG.decal=0;DG.origine=null;
  rPiste();
}
$('piste').addEventListener('pointerup',finDrag);
$('piste').addEventListener('pointercancel',finDrag);

$('piste').addEventListener('click',function(e){
  if(DG.bouge)return;
  var el=e.target.closest('.pose');
  if(el){ return; }
  var mv=e.target.closest('.mv[data-i]');
  if(!mv)return;
  var i=+mv.dataset.i;
  var p=sel?parUid(sel):null;
  if(p){
    /* Un charm est sélectionné : on le déplace sur ce maillon. */
    if(libre(p.type,i,p.uid)){ p.start=i; S.cible=null; rPiste(); }
    return;
  }
  S.cible=(S.cible===i)?null:i;
  rPiste();
});
$('sup').addEventListener('click',function(){if(sel)retirer(sel);});
$('fermer').addEventListener('click',function(){sel=null;rPiste();});
$('grille').addEventListener('click',function(e){
  var c=e.target.closest('[data-bb3-charm]');if(!c)return;
  var ch=c.__c||charm(c.dataset.id);if(!ch)return;

  /* swatch de couleur : on bascule la variante, comme dans ton BB2 */
  var sw=e.target.closest('.bb2-charm-swatch');
  if(sw){
    /* 01/11/2026 : toucher une couleur = poser CETTE couleur sur le bracelet.
       Couleur épuisée : la carte l'affiche grisée et on prévient, sans rien ajouter. */
    choisirSw(c,sw);
    if(!ch.dispo){ rGrille(); toast(tr('indispo')); return; }
    if(ch.modale){ rGrille(); ouvrirModale(ch); return; }
    ajouter(ch); return;
  }
  if(e.target.closest('.coeur')){
    var i=S.wish.indexOf(String(ch.id));
    if(i>=0){S.wish.splice(i,1);} else {S.wish.push(String(ch.id));}
    rGrille();rWish();return;
  }
  if(e.target.closest('.bb2-charm__minus')){retirerDe(ch.id);return;}
  /* Toute la carte ajoute : plus de bouton dédié, c'est le geste naturel
     sur téléphone où il n'y a pas de survol. */
  if(!ch.dispo){ toast(tr('indispo')); return; }
  if(ch.modale){ ouvrirModale(ch); return; }
  ajouter(ch);
});

/* même comportement au clavier, la carte est un bouton */
$('grille').addEventListener('keydown',function(e){
  if(e.key!=='Enter'&&e.key!==' ')return;
  var c=e.target.closest('[data-bb3-charm]'); if(!c||e.target!==c)return;
  e.preventDefault();
  var ch=c.__c||charm(c.dataset.id); if(!ch)return;
  if(!ch.dispo){ toast(tr('indispo')); return; }
  if(ch.modale){ ouvrirModale(ch); return; }
  ajouter(ch);
});
var qT=null;
$('q').addEventListener('input',function(e){
  S.q=e.target.value;S.limite=PAR_LOT;
  $('qx').style.display=S.q?'block':'none';
  clearTimeout(qT); qT=setTimeout(rGrille,150);
  if(S.q && typeof chargerSuite==='function') chargerSuite();
});
$('qx').addEventListener('click',function(){S.q='';S.limite=PAR_LOT;$('q').value='';this.style.display='none';rGrille();});
$('cats').addEventListener('click',function(e){var b=e.target.closest('[data-cat]');if(!b)return;
  S.cat=b.dataset.cat;S.limite=PAR_LOT;rCats();metalCat();ordreCat();rGrille();
  if(typeof chargerSuite==='function') chargerSuite(); /* tout le catalogue dès qu'on change d'onglet */});
/* 01/11/2026 : dans « Dorés » / « Argentés », chaque charm affiche uniquement sa variante
   dorée / argentée ; ailleurs, toutes les variantes. */
var RE_OR=/(^|\s)(dor|or$|or |gold|oro|goud|dorad|dorat)/i, RE_AR=/(argent|silver|silber|plata|zilver|plate)/i;
function choisirSw(c, sw){
  var ch=c.__c||charm(c.dataset.id); if(!ch||!sw) return;
  qq('.bb2-charm-swatch',c).forEach(function(x){x.classList.remove('is-active');});
  sw.classList.add('is-active');
  ch.vid=sw.dataset.vid; c.dataset.bb2LastVid=sw.dataset.vid;
  ch.prix=parseInt(sw.dataset.prix,10)||ch.prix; ch.img=sw.dataset.img||ch.img; ch.photo=sw.dataset.photo||ch.photo;
  ch.couleur=sw.dataset.couleur||ch.couleur;
  /* 01/11/2026 : le stock et la dispo suivent la variante choisie (une couleur épuisée
     s'affiche, grisée, avec « Victime de son succès », mais ne s'ajoute pas) */
  var q=parseInt(sw.dataset.qte,10); ch.qte=isNaN(q)?ch.qte:q;
  ch.dispo=sw.dataset.dispo!=='false';
  c.classList.toggle('sw-epuise',!ch.dispo);
  var ep=c.querySelector('.bb3-sw-ep');
  if(!ch.dispo && !ep){ var w=c.querySelector('.bb2-charm__img-wrap'); if(w){ ep=document.createElement('span'); ep.className='bb3-sw-ep'; ep.textContent=tr('motifEpuise'); w.appendChild(ep); } }
  var im=c.querySelector('.bb2-charm__img-wrap img'); if(im){ im.removeAttribute('srcset'); im.src=ch.photo; }
  var pr=c.querySelector('.bb2-charm__price'); if(pr) pr.textContent=sw.dataset.prixAff||eur(ch.prix);
}
function metalCat(){
  var h=String(S.cat||''), m=/argent/i.test(h)?'ar':(/dor/i.test(h)?'or':'');
  qq('#grille [data-bb3-charm]').forEach(function(c){
    var sws=qq('.bb2-charm-swatch',c); if(!sws.length) return;
    if(!m){ sws.forEach(function(x){x.classList.remove('bb3-sw-cache');}); return; }
    var re=m==='ar'?RE_AR:RE_OR, bon=null;
    /* la variante du bon métal, même épuisée : elle s'affiche alors comme épuisée */
    sws.forEach(function(x){ if(!bon && re.test(x.dataset.couleur||'') && x.dataset.dispo!=='false') bon=x; });
    sws.forEach(function(x){ if(!bon && re.test(x.dataset.couleur||'')) bon=x; });
    /* aucune variante du bon métal : on laisse tout visible */
    sws.forEach(function(x){ x.classList.toggle('bb3-sw-cache', !!bon && !re.test(x.dataset.couleur||'')); });
    if(bon && !bon.classList.contains('is-active')) choisirSw(c,bon);
  });
}
/* Ordre d'une catégorie = ordre de la collection dans Shopify (lu une fois, puis gardé) */
var ORDRES={}, ORDRE_BASE=null;
function ordreCat(){
  var g=$('grille'); if(!g||!g.appendChild) return;
  if(!ORDRE_BASE) ORDRE_BASE=DATA.charms.slice();
  var h=S.cat;
  function appliquer(rang){
    var liste=ORDRE_BASE.slice();
    if(rang){ liste.sort(function(a,b){ var ra=(rang[a.id]!==undefined?rang[a.id]:1e6), rb=(rang[b.id]!==undefined?rang[b.id]:1e6); return ra-rb; }); }
    var frag=document.createDocumentFragment(); liste.forEach(function(c){ frag.appendChild(c.el); }); g.appendChild(frag);
    DATA.charms=liste; encartsCle=''; rGrille();
  }
  if(!h || h==='tous' || h==='best' || h==='new'){ appliquer(null); return; }
  var src=h;
  if(ORDRES[src]){ appliquer(ORDRES[src]); return; }
  var racine=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/'), rang={}, n=0;
  function page(p){
    return fetch(racine+'collections/'+encodeURIComponent(src)+'/products.json?limit=250&page='+p,{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){ var ps=(d&&d.products)||[]; ps.forEach(function(x){ if(rang[String(x.id)]===undefined) rang[String(x.id)]=n++; }); if(ps.length===250 && p<8) return page(p+1); });
  }
  page(1).then(function(){ ORDRES[src]=rang; if(S.cat===h) appliquer(rang); }).catch(function(){});
}
$('plusbtn').addEventListener('click',function(){S.limite+=PAR_LOT;rGrille();});
/* Envoi de la liste : un tiers des commandes est payé par les parents,
   il faut pouvoir leur transmettre la sélection sans passer par le panier. */
$('wenvoi').addEventListener('click',function(){
  if(!S.wish.length)return;
  var noms=S.wish.map(function(id){var c=charm(id);return c?('• '+c.nom+' — '+eur(c.prix)):'';})
    .filter(Boolean).join('\n');
  var tot=S.wish.reduce(function(t,id){var c=charm(id);return t+(c?c.prix:0);},0);
  var lien=location.origin+location.pathname+'?liste='+encodeURIComponent(S.wish.join(','));
  var txt=tr('listeIntro')+'\n'+noms+'\n\nTotal : '+eur(tot)+'\n'+lien;
  if(navigator.share){ navigator.share({title:tr('maListe'),text:txt}).catch(function(){}); }
  else if(navigator.clipboard){ navigator.clipboard.writeText(txt); toast(tr('listeCopiee')); }
  else toast('Lien : '+lien);
});


$('wlist').addEventListener('click',function(e){
  var x=e.target.closest('[data-wx]');
  if(x){ var j=S.wish.indexOf(x.dataset.wx); if(j>=0)S.wish.splice(j,1); rGrille();rWish();persister(); return; }
  var w=e.target.closest('[data-w]');if(!w)return;
  var c=charm(w.dataset.w); if(!c)return;
  if(!c.dispo){ toast(tr('indispo')); return; }
  if(c.modale){ ouvrirModale(c); return; }
  ajouter(c);
  S.wish.splice(S.wish.indexOf(w.dataset.w),1);rGrille();rWish();persister();});

if($('selstrip').addEventListener) $('selstrip').addEventListener('click',function(e){
  var x=e.target.closest('[data-selx]');
  if(x){ retirer(x.dataset.selx); return; }
  var t=e.target.closest('[data-suid]');
  if(t){ sel=t.dataset.suid; rPiste();
    var sc=document.querySelector('.bb3 .scene');
    if(sc&&sc.scrollIntoView) window.scrollTo({top:sc.getBoundingClientRect().top+window.scrollY-
      (parseInt(getComputedStyle(RACINE).getPropertyValue('--hdr'),10)||0)-10,behavior:'smooth'});
  }
});

if($('wvider').addEventListener) $('wvider').addEventListener('click',function(){
  S.wish=[];rGrille();rWish();persister();});
$('outil').addEventListener('click',function(){S.outil=!S.outil;this.classList.toggle('on',S.outil);
  this.textContent=S.outil?tr('ajoute'):tr('ajouter');
  if(this.setAttribute)this.setAttribute('aria-pressed',S.outil?'true':'false');rRecap();});
document.addEventListener('click',function(e){var b=e.target.closest('[data-sup]');if(!b)return;
  if(b.dataset.sup==='__br'){ S.mode='have'; rendre(); return; }
  if(b.dataset.sup==='__o'){S.outil=false;$('outil').classList.remove('on');$('outil').textContent=tr('ajouter');rRecap();return;}
  if(b.dataset.sup.indexOf('u:')===0){ retirer(b.dataset.sup.slice(2),true); return; }
  retirerDe(b.dataset.sup);});
$('toastb').addEventListener('click',function(){
  if(videAnnulable){
    S.pose=videAnnulable.pose; S.outil=videAnnulable.outil; videAnnulable=null;
    if(S.outil){ $('outil').classList.add('on'); $('outil').textContent=tr('ajoute'); if($('outil').setAttribute) $('outil').setAttribute('aria-pressed','true'); }
    $('toast').classList.remove('on'); rendre(); return;
  }
  if(!dernier)return;
  if(!libre(dernier.type,dernier.start)){var s=place(dernier.type,occ());if(s<0){dernier=null;return;}dernier.start=s;}
  S.pose.push(dernier);dernier=null;$('toast').classList.remove('on');rPiste();rGrille();rRecap();});
/* Le panneau détaillé ne se déplie plus : la bande de sélection et le
   total suffisent, et le contenu dépliable ne portait plus aucune
   réassurance depuis qu'elle est remontée dans la page. */
/* ── Panier ── */
/* Le tiroir du thème Focal écoute « cart:refresh » sur <html> : il se
   recharge lui-même et s'ouvre avec openMiniCart. Sans tiroir, on va
   sur la page panier. */
function majPanierTheme(rep){
  var tiroir=document.querySelector('cart-drawer, #mini-cart');
  if(!tiroir){ window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart'; return; }
  /* 03/11/2026 : le panier est redessiné avec la section renvoyée par l'ajout (une requête de moins) */
  var det={openMiniCart:true};
  if(rep && rep.sections && rep.sections['mini-cart']){
    var nb=0; try{ nb=parseInt((document.querySelector('cart-count')||{}).textContent,10)||0; }catch(e){}
    (rep.items||[]).forEach(function(it){ nb+=it.quantity||0; });
    det.cart={sections:rep.sections,item_count:nb};
  }
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:det}));
  setTimeout(function(){ try{ tiroir.classList.remove('icx-chargement'); }catch(e){} },300);
  /* compteur exact en arrière-plan */
  fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js').then(function(r){return r.json();})
    .then(function(c){ document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:c}})); }).catch(function(){});
}
function ouvrirTiroirTot(){
  var t=document.querySelector('cart-drawer, #mini-cart'); if(!t)return;
  try{ t.classList.add('icx-chargement'); t.open=true; }catch(e){}
}
var envoiEnCours=false;
function panier(){
  if(envoiEnCours)return;
  if(S.mode==='first' && S.couleur.dispo===false){ toast(tr('braceletEpuise')); return; }
  if(S.outil && CFGS.outil && CFGS.outil.dispo===false){ S.outil=false; toast(tr('outilEpuise')); rRecap(); return; }
  var t=totaux();
  if(!t.nb&&!S.outil&&S.mode!=='first')return;
  var items=[],grp={};
  /* 27/10/2026 : chaque ligne de la compo porte la même mention visible
     (« Ta sélection : Bracelet doré + 10 charms ») pour que le panier et
     le checkout montrent qu'il s'agit d'un seul bracelet. Libellés déjà
     traduits (titre du récap, braceletLbl, charms). */
  var compo={};
  try{
    var stEl=$('sc').parentNode, cle=(stEl&&stEl.firstChild&&stEl.firstChild.textContent||'').trim()||'Ta sélection';
    var val=(avecBracelet()&&S.couleur&&S.couleur.nom)
      ? tr('braceletLbl',{couleur:S.couleur.nom.toLowerCase()})+' + '+t.nb+' '+(t.nb>1?tr('charms'):tr('charm'))
      : t.nb+' '+(t.nb>1?tr('charms'):tr('charm'));
    if(t.nb>0) compo[cle]=val;
  }catch(e){ compo={}; }
  if(!S.compo){ S.compo='c'+Date.now().toString(36); }
  compo['_bb3']=S.compo;
  function avecCompo(pr){ var o={}; Object.keys(compo).forEach(function(k){o[k]=compo[k];}); Object.keys(pr||{}).forEach(function(k){o[k]=pr[k];}); return o; }
  S.pose.forEach(function(p){
    if(p.sfx){ var pr={}; if(!p.vexacte) pr[p.sfxCle||'Lettre']=p.sfx; pr['_Maillon']=p.start+1;
      items.push({id:p.vid,quantity:1,properties:avecCompo(pr)}); }
    else grp[p.vid]=(grp[p.vid]||0)+1;
  });
  Object.keys(grp).forEach(function(v){items.push({id:v,quantity:grp[v],properties:avecCompo()});});
  if(avecBracelet()&&S.couleur.variantId){ var brq={}; brq[S.couleur.variantId]=1;
    brxListe().forEach(function(c){ if(c.variantId) brq[c.variantId]=(brq[c.variantId]||0)+1; });
    Object.keys(brq).reverse().forEach(function(v){ items.unshift({id:v,quantity:brq[v],properties:avecCompo()}); }); }
  if(S.outil&&CFGS.outil)items.push({id:CFGS.outil.variantId,quantity:1,properties:{_bb3:S.compo}});
  envoiEnCours=true;
  ['cta','mcta'].forEach(function(i){$(i).disabled=true;$(i).innerHTML=v4Cta(tr('ajoutEnCours'),'');});
  var urlAdd=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js';
  function envoyer(essai){
    return fetch(urlAdd,{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:items,sections:['mini-cart']})})
    .then(function(r){
      /* Shopify surchargé (429) ou indisponible (5xx) : une seconde chance */
      if((r.status===429||r.status>=500) && essai<1)
        return new Promise(function(ok){ setTimeout(ok,1500); }).then(function(){ return envoyer(essai+1); });
      /* Shopify répond 422 quand un article n'est plus en stock : sans ce
         contrôle, la sélection était vidée et le tiroir s'ouvrait vide.
         Une réponse qui n'est pas du JSON (page d'erreur) ne doit jamais
         afficher un message technique à la cliente. */
      return r.text().then(function(txt){
        var d=null; try{ d=JSON.parse(txt); }catch(e){}
        if(!r.ok || !d) throw (d && d.description ? d : {description:tr('erreurPanier')});
        return d;
      });
    });
  }
  /* 01/11/2026 : la composition reste affichée après l'ajout (on peut revenir la modifier
     plus tard). Si elle est déjà dans le panier, ses anciennes lignes sont remplacées. */
  var racine=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/');
  function retirerAncienne(){
    return fetch(racine+'cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var maj={}, n=0;
        (c.items||[]).forEach(function(it){ if(it.properties && it.properties._bb3===S.compo){ maj[it.key]=0; n++; } });
        if(!n) return null;
        return fetch(racine+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:maj})});
      })
      .catch(function(){ return null; });
  }
  /* 03/11/2026 : premier ajout de cette composition = pas de lecture préalable du panier ; le tiroir s'ouvre tout de suite */
  ouvrirTiroirTot();
  (S.dansPanier ? retirerAncienne() : Promise.resolve(null)).then(function(){ return envoyer(0); })
    .then(function(rep){
      envoiEnCours=false;
      S.dansPanier=true;
      persister();
      rRecap();
      majPanierTheme(rep);
    })
    .catch(function(e){
      try{ var t=document.querySelector('cart-drawer, #mini-cart'); t.classList.remove('icx-chargement'); t.open=false; }catch(er){}
      envoiEnCours=false;
      console.error('[BB3]',e);
      toast((e&&e.description)||tr('erreurPanier'));
      rRecap();
    });
}
['cta','mcta'].forEach(function(i){$(i).addEventListener('click',panier);});

/* Vider : on efface les charms et l'outil, on garde le bracelet et sa
   couleur — sinon on renvoie la cliente au point de départ. */
if($('svider').addEventListener) $('svider').addEventListener('click',viderTout);
$('partage').addEventListener('click',function(){
  var ids=S.pose.map(function(p){return p.pid+'@'+p.start;}).join('_');
  var url=location.origin+location.pathname+'?bb3='+encodeURIComponent(S.couleur.id+'|'+ids);
  if(navigator.share){ navigator.share({title:tr('partageTitre'),url:url}).catch(function(){}); }
  else if(navigator.clipboard){ navigator.clipboard.writeText(url); toast(tr('lienCopie')); }
  else toast('Lien : '+url);
});

/* ── Persistance ── */
function persister(){
  try{ localStorage.setItem(CLE, JSON.stringify({ts:Date.now(),mode:S.mode,couleur:S.couleur.id,motif:S.motif,compo:S.compo||'',
    outil:S.outil,brx:S.brx||[],wish:S.wish,pose:S.pose.map(function(p){
      return {pid:p.pid,vid:p.vid,nom:p.nom,type:p.type,prix:p.prix,img:p.img,photo:p.photo,start:p.start,sfx:p.sfx,sfxCle:p.sfxCle,vexacte:p.vexacte||false,qte:(p.qte===undefined?null:p.qte)};})}));
  }catch(e){}
}
/* Une sélection mémorisée garde l'image et le prix du jour où elle a été
   faite. On les reprend sur la carte actuelle dès qu'elle est chargée. */
function rafraichirPoses(){
  var change=false;
  S.pose.forEach(function(p){
    var c=charm(p.pid); if(!c)return;
    if(p.img!==c.img||p.prix!==c.prix){ p.img=c.img; p.photo=c.photo||p.photo; p.prix=c.prix; change=true; }
  });
  if(change){ rPiste(); rRecap(); }
}
function restaurer(){
  try{
    var raw=localStorage.getItem(CLE); if(!raw)return;
    var d=JSON.parse(raw); if(Date.now()-d.ts>TTL){localStorage.removeItem(CLE);return;}
    S.mode=d.mode||'first'; S.outil=!!d.outil; S.brx=(Array.isArray(d.brx)?d.brx:[]).filter(function(id){return !!brCoul(id);}).slice(0,BR_MAX-1); S.wish=d.wish||[]; S.compo=d.compo||'';
    COULEURS.forEach(function(c){if(c.id===d.couleur)S.couleur=c;});
    if(d.motif!==undefined)S.motif=d.motif;
    majCouleur();
    (d.pose||[]).forEach(function(p){p.uid='u'+(++seq);S.pose.push(p);});
    qq('[data-mode]',$('parcours')).forEach(function(x){x.classList.toggle('on',x.dataset.mode===S.mode);});
    if(S.outil){$('outil').classList.add('on');$('outil').textContent=tr('ajoute');}
  }catch(e){}
}

/* ── modale lettres ── */
var mC=null,mS={};
function valsModale(c){
  if(c.modale==='mois')return MOIS;
  return c.vars?c.vars.map(function(x){return x.t;}):LETTRES;
}
function lettreOff(c,i){ return !!(c.vars&&c.vars[i]&&c.vars[i].d===false); }
/* Combien de cette lettre peut-on encore ajouter (stock moins ce qui est déjà posé) */
function lettreReste(c,i){
  var v=c.vars&&c.vars[i]; if(!v||v.q===null||v.q<=0)return Infinity;
  var deja=S.pose.filter(function(p){return p.vid===v.id;}).length;
  return Math.max(0,v.q-deja);
}
/* Fenêtre « Choisis ta lettre » : grille 7 colonnes, on touche une lettre pour l'ajouter
   (on peut la toucher plusieurs fois), la sélection s'affiche en photos en bas et se retire
   avec la croix. L'ordre de sélection est gardé : c'est l'ordre de pose sur le bracelet. */
var mL=[];
function compteM(i){ return mL.filter(function(x){return x===i;}).length; }
function photoLettre(c,i){ var v=c.vars&&c.vars[i]; return (v&&v.img)||c.img||c.photo||''; }
function ouvrirModale(c){mC=c;mL=[];
  var mois=c.modale==='mois',vals=valsModale(c);
  $('mt').textContent=mois?tr('choisirMois'):tr('choisirLettre');
  $('mst').textContent=c.nom+' · '+eur(c.prix)+' '+tr('laLettre');
  $('modale').classList.toggle('mois',mois);
  $('mg').innerHTML=vals.map(function(v,i){
    if(lettreOff(c,i)) return '<div class="lt lt--off" aria-disabled="true" aria-label="'+v+', '+tr('motifEpuise')+'"><span class="lt-l">'+v+'</span></div>';
    return '<div class="lt" data-v="'+i+'" role="button" tabindex="0" aria-label="'+tr('ajouterLettre')+' '+v+'"><span class="lt-l">'+v+'</span><span class="lt-b" aria-hidden="true"></span></div>';}).join('');
  $('modale').classList.add('on');document.body.style.overflow='hidden';majModale();
  ouvrirDialogue($('modale'));}
function majModale(){
  qq('.lt[data-v]',$('mg')).forEach(function(el){var n=compteM(+el.dataset.v);
    el.classList.toggle('on',n>0);el.querySelector('.lt-b').textContent=n||'';});
  var vals=valsModale(mC), t=mL.length;
  $('mch').innerHTML=t?mL.map(function(i,k){var im=photoLettre(mC,i);
    return '<span class="mchip">'+(im?'<img src="'+im+'" alt="'+vals[i]+'">':'<b>'+vals[i]+'</b>')+
      '<button type="button" data-k="'+k+'" aria-label="'+tr('retirerLettre')+' '+vals[i]+'">×</button></span>';}).join('')
    :'<span class="mvide">'+tr('aucuneLettre')+'</span>';
  if(t){ var ch=$('mch'); ch.scrollLeft=ch.scrollWidth; }
  $('mok').disabled=t===0;
  $('mok').innerHTML=t?(tr(t>1?'ajouterNLettres':'ajouter1Lettre',{n:t})+' <span class="mok-p">· '+eur(t*mC.prix)+'</span>'):tr('choisisUneLettre');}
function ajoutM(k){ if(compteM(k)>=lettreReste(mC,k)){toast(tr('lettreMax'));return;} mL.push(k); majModale(); }
$('mg').addEventListener('click',function(e){
  var b=e.target.closest('[data-v]'); if(b){ ajoutM(+b.dataset.v); return; }
  if(e.target.closest('.lt--off')) toast(tr('lettreEpuisee'));});
$('mg').addEventListener('keydown',function(e){
  if(e.key!=='Enter'&&e.key!==' ')return; var b=e.target.closest('[data-v]'); if(!b)return;
  e.preventDefault(); ajoutM(+b.dataset.v);});
$('mch').addEventListener('click',function(e){
  var x=e.target.closest('[data-k]'); if(!x)return; mL.splice(+x.dataset.k,1); majModale();});
$('mok').addEventListener('click',function(){
  var mois=mC.modale==='mois',vals=valsModale(mC);
  mL.forEach(function(i){ ajouter(mC,{sfx:vals[i],cle:mois?'Mois':'Lettre'}); });
  fermerModale();});
function fermerModale(){$('modale').classList.remove('on');document.body.style.overflow='';fermerDialogue();}
/* ── Fenêtres accessibles : focus à l'ouverture, Échap pour fermer,
   Tab reste dans la fenêtre, et retour du focus à la fermeture. ── */
var dlg=null, dlgAvant=null;
function focusables(c){ return Array.prototype.filter.call(
  c.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'),
  function(x){ return !x.disabled && x.getClientRects().length>0; }); }
function ouvrirDialogue(c){
  dlg=c; dlgAvant=document.activeElement;
  setTimeout(function(){ var f=focusables(c); var t=f[0]||c; if(t.focus) t.focus(); },30);
}
function fermerDialogue(){
  var a=dlgAvant; dlg=null; dlgAvant=null;
  if(a&&a.focus&&document.body.contains(a)) a.focus({preventScroll:true});
}
document.addEventListener('keydown',function(e){
  if(!dlg)return;
  if(e.key==='Escape'){ if(dlg===$('modale')) fermerModale(); return; }
  if(e.key!=='Tab')return;
  var f=focusables(dlg); if(!f.length)return;
  var i=f.indexOf(document.activeElement);
  if(e.shiftKey&&(i<=0)){ e.preventDefault(); f[f.length-1].focus(); }
  else if(!e.shiftKey&&(i===f.length-1)){ e.preventDefault(); f[0].focus(); }
});
$('mx').addEventListener('click',fermerModale);$('mfond').addEventListener('click',fermerModale);

/* ── inspirations, démos, avis ── */
function miniHTML(ids,total,cw){
  var pas=cw*0.89,o={},poses=[];
  ids.map(charm).filter(Boolean).forEach(function(c){
    for(var s=0;s<total;s++){if(cases(c.type,s).every(function(x){return !o[x];})){
      cases(c.type,s).forEach(function(x){o[x]=1;});poses.push({uid:'m'+Math.random(),type:c.type,img:c.img,start:s});break;}}});
  var lc={};poses.forEach(function(p){if(p.type==='chaine3'||p.type==='chaine4')
    for(var k=p.start+1;k<p.start+portee(p.type)-1;k++)lc[k]=1;});
  var rail='';for(var i=0;i<total;i++)
    rail+='<div class="mv '+(S.couleur.ton==='ar'?'metal-ar':'metal-or')+(S.couleur.img?' img':'')+'">'+
      (S.couleur.img?'<img src="'+S.couleur.img+'" alt="">':'')+'</div>';
  var couche=poses.map(function(p){var n=portee(p.type);
    return '<div class="pose '+p.type+'" style="left:'+(p.start*pas)+'px;width:'+(cw+(n-1)*pas)+'px"><img src="'+p.img+'"></div>';}).join('');
  return '<div class="rail">'+rail+'<div class="couche" style="width:'+(cw+(total-1)*pas)+'px">'+couche+'</div></div>';
}


(function(){var f;try{f=new Intl.DateTimeFormat(CFGS.locale||'fr-FR',{weekday:'short',day:'numeric',month:'long'});}catch(e){f=new Intl.DateTimeFormat('fr-FR',{weekday:'short',day:'numeric',month:'long'});}
 function o(j){var d=new Date(),n=0;while(n<j){d.setDate(d.getDate()+1);if(d.getDay()!==0&&d.getDay()!==6)n++;}return f.format(d);}
 var L=(window.IC_LIV&&window.IC_LIV.length===2)?window.IC_LIV:[2,4];var a=o(L[0]),b=o(L[1]);['d1','d3'].forEach(function(i){$(i).textContent=a;});['d2','d4'].forEach(function(i){$(i).textContent=b;});})();

/* hauteur du header collant du thème, pour que le bracelet se colle dessous */
function mesurerHeader(){
  /* On additionne TOUS les bandeaux collants du thème — barre
     d'annonce et en-tête — au lieu de s'arrêter au premier trouvé.
     Sinon le bracelet se cale trop haut et passe par-dessus. */
  /* 27/10/2026 : dans ce thème, les sections du groupe d'en-tête s'appellent
     shopify-section-sections--<id>__announcement-bar / __header /
     __reassuranec_bar_… : aucun des anciens sélecteurs ne les trouvait et
     --hdr restait à 0, le bracelet collant passait sous les trois barres.
     On prend désormais le bord bas le plus bas parmi les éléments collants
     ou fixes du groupe d'en-tête réellement affichés en haut de l'écran
     (un en-tête replié au défilement ne compte que pour ce qui dépasse). */
  var h=0, vus=[];
  var sels='#shopify-section-announcement-bar,.announcement-bar,#shopify-section-header,'+
    'sticky-header,.header,header[role="banner"],.shopify-section-group-header-group';
  Array.prototype.forEach.call(document.querySelectorAll(sels),function(el){
    if(vus.indexOf(el)>=0)return;
    var st=getComputedStyle(el);
    if(st.position==='sticky'||st.position==='fixed'){
      var r=el.getBoundingClientRect();
      if(r.height>0 && r.bottom>0 && r.top<r.height+2){ h=Math.max(h,r.bottom); vus.push(el); }
    }
  });
  RACINE.style.setProperty('--hdr',Math.round(h)+'px');
  reserverBas();
}
/* 27/10/2026 : la barre « Ta sélection » est fixée en bas de l'écran sur
   mobile. Sans réserve, elle recouvre la fin du pied de page (paiements,
   mentions). On ajoute au body une marge basse égale à sa hauteur réelle,
   remise à zéro dès qu'elle disparaît (écran large). */
function reserverBas(){
  var sh=$('sheet'); if(!sh||!sh.getBoundingClientRect)return;
  var st=getComputedStyle(sh), r=sh.getBoundingClientRect();
  var hs=(st.display!=='none'&&st.position==='fixed')?Math.round(r.height):0;
  document.body.style.paddingBottom=hs?hs+'px':'';
}
if(window.ResizeObserver&&$('sheet')&&$('sheet').getBoundingClientRect){
  try{ new ResizeObserver(function(){reserverBas();}).observe($('sheet')); }catch(e){}
}
mesurerHeader();
window.addEventListener('resize',mesurerHeader,{passive:true});
/* le header du thème peut se replier au défilement : on remesure */
window.addEventListener('scroll',function(){
  if(window.__bb3h)return;
  window.__bb3h=setTimeout(function(){window.__bb3h=null;mesurerHeader();},250);
},{passive:true});
setTimeout(mesurerHeader,800);

var largeurVue=window.innerWidth;
window.addEventListener('resize',function(){
  if(window.innerWidth===largeurVue)return;
  largeurVue=window.innerWidth; rPiste();
},{passive:true});

/* Mini-bracelets illustrant les colonnes « comment ça marche » */
(function(){
  var jeux = { vide:[], chaine:['x2','c1','c7'], pendentif:['p1','c2','c3'] };
  qq('.mini[data-demo]').forEach(function(el){
    var ids = jeux[el.dataset.demo];
    if(!ids) return;
    var reels = ids.map(function(i){ return charm(i); }).filter(Boolean);
    if(!reels.length && el.dataset.demo!=='vide'){
      /* pas de charm portant cet identifiant : on prend les premiers du bon type */
      var t = el.dataset.demo==='chaine' ? ['chaine3','chaine4'] : ['pendentif'];
      reels = DATA.charms.filter(function(c){ return t.indexOf(c.type)>=0; }).slice(0,1)
        .concat(DATA.charms.filter(function(c){ return c.type==='plat'; }).slice(0,2));
    }
    el.innerHTML = miniHTML(reels.map(function(c){ return c.id; }), 8, 26);
  });
})();



/* ── Preuves : claim court en pastille, détail complet au clic ──
   Le détail est déjà dans la page, masqué. On le déplace dans la
   fenêtre plutôt que de le reconstruire : aucun risque d'échappement. */
(function(){
  var mod=$('pvmod'), corps=$('pvbody');
  if(!mod||!mod.classList)return;
  function ouvrir(i){
    var src=document.getElementById('pv-'+i);
    if(!src)return;
    corps.innerHTML=src.innerHTML;
    var h=corps.querySelector('h2,h3'); if(h) h.id='pvtitre';
    mod.classList.add('on');
    document.body.style.overflow='hidden';
    ouvrirDialogue(mod);
  }
  function fermer(){ if(!mod.classList.contains('on'))return; mod.classList.remove('on'); document.body.style.overflow=''; fermerDialogue(); }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-pv]');
    if(b){ e.preventDefault(); ouvrir(b.dataset.pv); return; }
    if(e.target.closest('#pvfond')||e.target.closest('#pvx')) fermer();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape')fermer(); });
})();

/* ── Pastille « voir mon bracelet » ──
   Elle n'apparaît que si le bracelet est sorti de l'écran, avec le
   nombre de charms posés. Rien ne bouge tout seul. */
(function(){
  var b=$('remonter'), sc=document.querySelector('.bb3 .scene');
  if(!b||!sc||!b.addEventListener)return;
  b.addEventListener('click',function(){
    window.scrollTo({top:sc.getBoundingClientRect().top+window.scrollY-(parseInt(
      getComputedStyle(RACINE).getPropertyValue('--hdr'),10)||0)-10,behavior:'smooth'});
  });
  function maj(){
    var r=sc.getBoundingClientRect();
    var dehors=r.bottom<60;
    b.classList.toggle('on',dehors&&S.pose.length>0);
    var n=b.querySelector('span');
    if(n)n.textContent=S.pose.length;
  }
  if(window.IntersectionObserver){
    new IntersectionObserver(maj,{threshold:0}).observe(sc);
  }
  /* Pas d'écouteur scroll : l'IntersectionObserver suffit, et rRecap
     appelle BR_MAJ à chaque changement du bracelet. */
  BR_MAJ=maj;
})();

/* le message se cale au-dessus de la barre mobile, quelle que soit sa hauteur */
(function(){
  /* La hauteur de la barre pilote la réserve de place en bas de page.
     On la remesure à chaque changement de contenu, sinon la réserve
     reste à sa valeur de repli et laisse un vide visible. */
  function h(){
    var sh=document.querySelector('.bb3 .sheet');
    var v = (sh && getComputedStyle(sh).display!=='none') ? Math.ceil(sh.getBoundingClientRect().height) : 0;
    RACINE.style.setProperty('--sheet-h', v+'px');
  }
  window.BB3_MAJ_H = h;
  h();
  window.addEventListener('resize',h,{passive:true});
  window.addEventListener('load',h);
  setTimeout(h,300); setTimeout(h,1200);
  if(window.ResizeObserver){
    var sh=document.querySelector('.bb3 .sheet');
    if(sh) new ResizeObserver(h).observe(sh);
  }
})();

/* ── Bandeau de confiance : défile tout seul, avec des points ── */
(function(){
  var t=document.querySelector('.bb3 .tstrip'); if(!t)return;
  var n=t.children.length; if(n<2)return;
  var pts=document.createElement('div'); pts.className='tdots';
  for(var i=0;i<n;i++){var d=document.createElement('span');if(!i)d.className='on';pts.appendChild(d);}
  t.parentNode.insertBefore(pts,t.nextSibling);
  var cur=0, auto=null, manuel=false;
  function aller(i){ cur=(i+n)%n; t.scrollTo({left:t.children[cur].offsetLeft-t.offsetLeft,behavior:'smooth'});
    qq('span',pts).forEach(function(s,k){s.className=k===cur?'on':'';}); }
  function demarrer(){ if(auto||window.innerWidth>=720)return;
    auto=setInterval(function(){ if(!manuel)aller(cur+1); },4200); }
  function arreter(){ clearInterval(auto); auto=null; }
  pts.addEventListener('click',function(e){var i=Array.prototype.indexOf.call(pts.children,e.target);
    if(i>=0){manuel=true;aller(i);}});
  t.addEventListener('pointerdown',function(){manuel=true;});
  t.addEventListener('scroll',function(){
    var i=Math.round(t.scrollLeft/(t.children[0].offsetWidth||1));
    if(i!==cur&&i>=0&&i<n){cur=i;qq('span',pts).forEach(function(s,k){s.className=k===cur?'on':'';});}
  },{passive:true});
  demarrer();
  window.addEventListener('resize',function(){ arreter(); demarrer(); },{passive:true});
})();

/* ── Chargement du reste du catalogue ──
   La section renvoie les charms par pages de 50 en JSON.
   On garde ainsi les metafields, que products.json ne donne pas. */
var suiteLancee=false, suiteFinie=false;
/* Composition reçue par lien (« Envoyer ma composition ») :
   ?bb3=couleur|idcharm@maillon_idcharm@maillon… */
var partageRecu=(function(){var m=location.search.match(/[?&]bb3=([^&]+)/);
  try{ return m?decodeURIComponent(m[1]):null; }catch(e){ return null; }})();
/* 27/10/2026 : ?charm=<handle> (depuis la fiche produit, formule « Je choisis
   mes autres charms ») : le charm arrive déjà posé sur le bracelet, comme la
   fiche le promet. Une seule fois, et seulement s'il n'y est pas déjà. */
var charmRecu=(function(){var m=location.search.match(/[?&]charm=([^&]+)/);
  try{ return m?decodeURIComponent(m[1]).toLowerCase():null; }catch(e){ return null; }})();
function appliquerCharmRecu(){
  if(!charmRecu)return;
  var h=charmRecu; charmRecu=null;
  var c=null; for(var i=0;i<DATA.charms.length;i++){ if((DATA.charms[i].handle||'').toLowerCase()===h){ c=DATA.charms[i]; break; } }
  if(!c||!c.dispo||c.modale)return;
  if(compte(c.id)>0)return;
  ajouter(c);
  try{ var u=new URL(location.href); u.searchParams.delete('charm'); history.replaceState(null,'',u); }catch(e){}
}
var listeRecue=null;
function appliquerListeRecue(){
  if(!listeRecue)return;
  var ids=listeRecue; listeRecue=null;
  var n=0;
  ids.forEach(function(id){ var c=charm(id); if(!c||!c.dispo||c.modale)return; if(compte(c.id)>0)return; var av=S.pose.length; ajouter(c); if(S.pose.length>av)n++; });
  try{ var u=new URL(location.href); u.searchParams.delete('liste'); history.replaceState(null,'',u); }catch(e){}
  if(n) rendre();
}
function appliquerPartage(){
  appliquerCharmRecu();
  appliquerListeRecue();
  if(!partageRecu)return;
  var parts=partageRecu.split('|'); partageRecu=null;
  COULEURS.forEach(function(c){ if(c.id===parts[0]){ S.couleur={nom:c.nom}; S.motif=c.motif; majCouleur(); } });
  S.mode='first'; S.pose=[]; S.brx=[]; sel=null; S.cible=null;
  (parts[1]||'').split('_').forEach(function(x){
    var q=x.split('@'), c=charm(q[0]); if(!c||!c.dispo||c.modale)return;
    var st=parseInt(q[1],10), o=occ();
    if(isNaN(st)||!cases(c.type,st).every(function(k){return !o[k]&&k<CFG.max;})) st=place(c.type,o);
    if(st<0)return;
    S.pose.push({uid:'u'+(++seq),pid:c.id,vid:c.vid||c.id,nom:c.nom,type:c.type,prix:c.prix,
      img:c.img,photo:c.photo||c.img,start:st,sfx:null,sfxCle:null});
  });
  rendre();
}
function chargerSuite(){
  if(suiteLancee)return; suiteLancee=true;
  var pages=parseInt(CFGS.pages||1,10);
  if(pages<2||!CFGS.sectionId){ suiteFinie=true; appliquerPartage(); return; }
  var grille=$('grille'), base=location.pathname, restant=[], fin=Math.min(pages,30);
  for(var n=2;n<=fin;n++) restant.push(n);
  var recus={};
  /* Un lot après l'autre (Shopify refuse les rafales), et une seule mise à
     jour de la grille à la fin : avant, chaque lot relançait le calcul des
     ~490 cartes (9 fois). */
  function suivant(){
    var n=restant.shift(); if(n===undefined) return Promise.resolve();
    var url=base+'?section_id='+encodeURIComponent(CFGS.sectionId)+'&page='+n;
    function essai(k){
      return fetch(url).then(function(r){
        /* 429 = trop de requêtes d'un coup : on patiente et on réessaie */
        if(r.status===429 && k<4) return new Promise(function(ok){ setTimeout(ok,700*(k+1)); }).then(function(){ return essai(k+1); });
        if(!r.ok) throw new Error('page '+n+' : HTTP '+r.status);
        return r.text().then(function(h){ recus[n]=h; });
      });
    }
    return essai(0).catch(function(e){ console.error('[BB3] chargement',e); }).then(suivant);
  }
  suivant().then(function(){
    var ajoutes=0;
    for(var k=2;k<=fin;k++){
      if(!recus[k])continue;
      var tmp=document.createElement('div'); tmp.innerHTML=recus[k];
      Array.prototype.forEach.call(tmp.querySelectorAll('[data-bb3-charm]'),function(el){
        if(grille.querySelector('[data-id="'+el.dataset.id+'"]'))return;
        grille.appendChild(el); ajoutes++;
      });
    }
    suiteFinie=true;
    if(ajoutes){ lireCartes(); rafraichirPoses(); }
    ordonner(); ORDRE_BASE=null; rGrille(); rWish();
    /* 01/11/2026 : les cartes arrivées après coup suivent aussi l'onglet en cours */
    metalCat(); if(S.cat && S.cat!=='tous' && S.cat!=='best' && S.cat!=='new') ordreCat();
    appliquerPartage();
    diag(DATA.charms.length+' charms chargés');
  });
}
/* Le reste du catalogue arrive quand la grille approche de l'écran, ou dès
   qu'on cherche / change d'onglet / arrive avec une liste partagée. */
function lancerSuiteAuBesoin(){
  var g=document.getElementById('grille');
  if(!g||!window.IntersectionObserver){ setTimeout(chargerSuite,400); return; }
  /* On surveille la FIN des 50 premiers charms, pas le début de la grille :
     avant, la grille étant presque visible à l'ouverture, les 9 lots
     suivants (~440 cartes) partaient au démarrage et plombaient la vitesse. */
  var sentinelle=g.lastElementChild||g;
  var io=new IntersectionObserver(function(es){
    if(es.some(function(e){return e.isIntersecting;})){ io.disconnect(); chargerSuite(); }
  },{rootMargin:'0px 0px 900px 0px'});
  io.observe(sentinelle);
  ['q','cats'].forEach(function(id){
    var el=document.getElementById(id);
    if(el) el.addEventListener(id==='q'?'input':'click',chargerSuite,{once:true});
  });
  if(S.wish.length||S.pose.length||partageRecu||charmRecu) chargerSuite();
}

try {
  lireCartes();
  ordonner();
  restaurer();
  rafraichirPoses();
  /* liste reçue par lien : on la restitue telle quelle */
  (function(){
    var m=location.search.match(/[?&]liste=([^&]+)/);
    if(!m)return;
    S.wish=decodeURIComponent(m[1]).split(',').filter(Boolean);
    /* 03/11/2026 : la liste reçue est aussi posée directement dans la sélection
       (après le chargement complet du catalogue, voir appliquerPartage). */
    listeRecue=S.wish.slice();
  })();
  rendre();
  diag(DATA.charms.length + ' charms chargés · ' + COULEURS.length + ' couleur(s) · maillon ' +
    (S.couleur.img ? 'image OK' : 'AUCUNE IMAGE') + ' · variante bracelet ' +
    (S.couleur.variantId ? S.couleur.variantId : 'ABSENTE') + ' · ' + CATS.length + ' catégorie(s)');
} catch(err) {
  console.error('[BB3]', err);
  diag((err && err.message ? err.message : err) + ' — ligne ' + ((err && err.lineNumber) || '?'), true);
}
lancerSuiteAuBesoin();
if(document.getElementById('bb3-diag-js')) setTimeout(chercherDebordement,900);

} catch(erreurGlobale) {
  console.error('[BB3] erreur au chargement :', erreurGlobale);
  var dg = document.getElementById('bb3-diag-js');
  if (dg) dg.innerHTML = '<em>JS EN ERREUR : ' +
    (erreurGlobale && erreurGlobale.message ? erreurGlobale.message : erreurGlobale) + '</em>';
}
})();
/* 02/11/2026 : le builder est prêt → la barre du bas peut s'afficher sans sauter */
try{ document.querySelectorAll('.bb3').forEach(function(e){ e.classList.add('bb3-pret'); }); }catch(e){}
